
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as giftsdy92eEQaAuorFU_Rlm6rnSxHRvVvrE4_JvXpc69q_xIMeta } from "/vercel/path0/pages/[locale]/gifts.vue?macro=true";
import { default as indexKF2hiuGcjkEy_45cFcJ06grL9Ckhj7CsQ_45f4NWo_KyDewMeta } from "/vercel/path0/pages/[locale]/index.vue?macro=true";
import { default as index1ZHHDOlaThuaFHksUamwxH2Toc0HiOI0czOUbkyJ8OMMeta } from "/vercel/path0/pages/[locale]/owners/index.vue?macro=true";
import { default as _91product_93wKQlgi3zODwczFESy_rX3lZ5CRNeDsUA_6w30IMr_45L4Meta } from "/vercel/path0/pages/[locale]/owners/[product].vue?macro=true";
import { default as ownerso7iR9Q1qqbg_45z7rxc8AJs9v_QqsFd8eZxYdvtrw6_45PoMeta } from "/vercel/path0/pages/[locale]/owners.vue?macro=true";
import { default as careersUtm6zF1DsFm_45Ge2k3TSsymQJ2FSoL6wkWfWzTX_AvUQMeta } from "/vercel/path0/pages/[locale]/careers.vue?macro=true";
import { default as reviewsFN0UnmDsAq4AGO7WvjoyZjMzmxrM2ZoCRFjenDEf5oUMeta } from "/vercel/path0/pages/[locale]/reviews.vue?macro=true";
import { default as sitemapIZsokalzU8WSfxzC8LzLikaNJIhcNCILYv4H9t_45j_DoMeta } from "/vercel/path0/pages/[locale]/sitemap.vue?macro=true";
import { default as indexcapE4oqY2b8Rz_kiJIYfGgt92c4KuAv_xIimBDk0XdwMeta } from "/vercel/path0/pages/[locale]/support/[category]/[article]/index.vue?macro=true";
import { default as _91category_93Bz39e1hHExYIgqpo3Z7UzwiOg1hEwVLrs7WmHu755z0Meta } from "/vercel/path0/pages/[locale]/support/[category].vue?macro=true";
import { default as sentJjKerZQjWqv5_45Irx5911CTq79tqTRrZ2eZMFzybAtB8Meta } from "/vercel/path0/pages/[locale]/support/contact-us/sent.vue?macro=true";
import { default as indexKeK0OAddG_4536l5EnZQr7ZTwvuM_45bTXQKo3tKs_gLhC0Meta } from "/vercel/path0/pages/[locale]/support/contact-us/index.vue?macro=true";
import { default as supportQnWXrTJXuSp6KUv2htpVgM2j9iFs_45eszzWyUPsd3QmAMeta } from "/vercel/path0/pages/[locale]/support.vue?macro=true";
import { default as welcomeNdDNYeC3h6BvIoUQt6ufXhIhepyZZW4xpGrqmDJbRV8Meta } from "/vercel/path0/pages/[locale]/welcome.vue?macro=true";
import { default as _91slug_93dCoEM4kJeeG910YitiBfNI_g31CKIy_45ePLLFtQsf_GQMeta } from "/vercel/path0/pages/[locale]/info/[slug].vue?macro=true";
import { default as loginoLeG1w_E3RunKkruqxGz90xRlyVF4JMNW9pMhyfNF_0Meta } from "/vercel/path0/pages/[locale]/account/login.vue?macro=true";
import { default as index_SHmmbNGY6dLzztDmEjYmp6rxSPnXHEpujdf9iZNFYQMeta } from "/vercel/path0/pages/[locale]/explore/index.vue?macro=true";
import { default as redirectguXv7NCo26S0Gsz2HQhHY3tZJveDmvuKp3KcR7DckyIMeta } from "/vercel/path0/pages/[locale]/shop/redirect.vue?macro=true";
import { default as returns_46clientSDM0z_45EaXdIwxTcp2tx2ZrUrHtEketsnpsPKQnglppgMeta } from "/vercel/path0/pages/[locale]/returns.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/vercel/path0/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as instagramFXLt_IuglN34cXXM7VpbWxOMBpUURmqECRlpAN854fYMeta } from "/vercel/path0/pages/[locale]/shop/instagram.vue?macro=true";
import { default as _91_46_46_46page_93aBT43oKTVErKa_5mHMXe7OvwKwZxIhjvwiK7g1jp3dIMeta } from "/vercel/path0/pages/[locale]/test/[...page].vue?macro=true";
import { default as _91slug_93dFnL6vzNaTWgpQoJe8G5jjdQWdohcI5KdVI6RuPYDCgMeta } from "/vercel/path0/pages/[locale]/register/[slug].vue?macro=true";
import { default as _91slug_93V6C6XWwW7D2c6VV2k8zY42ixM3b4zhHzxZ6VMOOx3R0Meta } from "/vercel/path0/pages/[locale]/typeform/[slug].vue?macro=true";
import { default as indexK5nE51U6cXXaLyaffp5m9iO31h2iT668i2FI0wPW3f0Meta } from "/vercel/path0/pages/[locale]/account/dashboard/returns/index.vue?macro=true";
import { default as _91orderid_934F6_xkBho080GbBMzqmcUUbajGM0bbxGpDPTovpB5JwMeta } from "/vercel/path0/pages/[locale]/account/dashboard/orders/[orderid].vue?macro=true";
import { default as dashboard5pB44QspbX5kQXFZ0_TfX3t3Mki0aJ771s0BIMiw0HwMeta } from "/vercel/path0/pages/[locale]/account/dashboard.vue?macro=true";
import { default as _91discount_93g228A0zFklpDgOz1EpdDPVjq3Dei1nK0LA70DQy61P8Meta } from "/vercel/path0/pages/[locale]/discount/[discount].vue?macro=true";
import { default as prescriptionuc3bFinWw4rpEF5dOTQblxZ3r_e23WhgTNtt1r824CUMeta } from "/vercel/path0/pages/[locale]/checkout/prescription.vue?macro=true";
import { default as indexUv9VkEPT7WUxH_4NG57wzE_1AhKGfJJsVk6zU7Ryeo8Meta } from "/vercel/path0/pages/[locale]/shop/[category]/index.vue?macro=true";
import { default as indexDiWneYgQrNRk9QwqHwotmdTGsOTPVilK_45hx_cmUR2ywMeta } from "/vercel/path0/pages/[locale]/explore/[category]/index.vue?macro=true";
import { default as _91article_93Eql5k3RwiwsoFKc1Uv_WKqPlwZguaxQm8bROXv5DMmkMeta } from "/vercel/path0/pages/[locale]/explore/[category]/[article].vue?macro=true";
import { default as _91_46_46_46filter_45page_93hyv7TXs78CgnxBXo8jzzE9of0UDbkr8tz1MaugIARCEMeta } from "/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue?macro=true";
import { default as index9YM3mwjYJIkLveeLLxnkPhDHDZxssi8_45jH9k4glA4XUMeta } from "/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue?macro=true";
import { default as _91_46_46_46generic_45landing_45page_93MJqUUgOOa8lARdm4Pft9_45PYDdWQ2t5Y78wa3w_45H6lcEMeta } from "/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "locale-gifts",
    path: "/:locale()/gifts",
    meta: giftsdy92eEQaAuorFU_Rlm6rnSxHRvVvrE4_JvXpc69q_xIMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/gifts.vue")
  },
  {
    name: "Home",
    path: "/:locale()",
    meta: indexKF2hiuGcjkEy_45cFcJ06grL9Ckhj7CsQ_45f4NWo_KyDewMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/index.vue")
  },
  {
    name: ownerso7iR9Q1qqbg_45z7rxc8AJs9v_QqsFd8eZxYdvtrw6_45PoMeta?.name,
    path: "/:locale()/owners",
    component: () => import("/vercel/path0/pages/[locale]/owners.vue"),
    children: [
  {
    name: "locale-owners",
    path: "",
    component: () => import("/vercel/path0/pages/[locale]/owners/index.vue")
  },
  {
    name: "locale-owners-product",
    path: ":product()",
    component: () => import("/vercel/path0/pages/[locale]/owners/[product].vue")
  }
]
  },
  {
    name: "locale-careers",
    path: "/:locale()/careers",
    meta: careersUtm6zF1DsFm_45Ge2k3TSsymQJ2FSoL6wkWfWzTX_AvUQMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/careers.vue")
  },
  {
    name: "locale-reviews",
    path: "/:locale()/reviews",
    meta: reviewsFN0UnmDsAq4AGO7WvjoyZjMzmxrM2ZoCRFjenDEf5oUMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/reviews.vue")
  },
  {
    name: "locale-sitemap",
    path: "/:locale()/sitemap",
    component: () => import("/vercel/path0/pages/[locale]/sitemap.vue")
  },
  {
    name: "SupportPage",
    path: "/:locale()/support",
    meta: supportQnWXrTJXuSp6KUv2htpVgM2j9iFs_45eszzWyUPsd3QmAMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/support.vue"),
    children: [
  {
    name: "locale-support-category",
    path: ":category()",
    meta: _91category_93Bz39e1hHExYIgqpo3Z7UzwiOg1hEwVLrs7WmHu755z0Meta || {},
    component: () => import("/vercel/path0/pages/[locale]/support/[category].vue"),
    children: [
  {
    name: "locale-support-category-article",
    path: ":article()",
    meta: indexcapE4oqY2b8Rz_kiJIYfGgt92c4KuAv_xIimBDk0XdwMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/support/[category]/[article]/index.vue")
  }
]
  },
  {
    name: "locale-support-contact-us-sent",
    path: "contact-us/sent",
    component: () => import("/vercel/path0/pages/[locale]/support/contact-us/sent.vue")
  },
  {
    name: "locale-support-contact-us",
    path: "contact-us",
    meta: indexKeK0OAddG_4536l5EnZQr7ZTwvuM_45bTXQKo3tKs_gLhC0Meta || {},
    component: () => import("/vercel/path0/pages/[locale]/support/contact-us/index.vue")
  }
]
  },
  {
    name: "WelcomePage",
    path: "/:locale()/welcome",
    meta: welcomeNdDNYeC3h6BvIoUQt6ufXhIhepyZZW4xpGrqmDJbRV8Meta || {},
    component: () => import("/vercel/path0/pages/[locale]/welcome.vue")
  },
  {
    name: "locale-info-slug",
    path: "/:locale()/info/:slug()",
    component: () => import("/vercel/path0/pages/[locale]/info/[slug].vue")
  },
  {
    name: "locale-account-login",
    path: "/:locale()/account/login",
    component: () => import("/vercel/path0/pages/[locale]/account/login.vue")
  },
  {
    name: "ExploreListing",
    path: "/:locale()/explore",
    meta: index_SHmmbNGY6dLzztDmEjYmp6rxSPnXHEpujdf9iZNFYQMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/explore/index.vue")
  },
  {
    name: "locale-shop-redirect",
    path: "/:locale()/shop/redirect",
    meta: redirectguXv7NCo26S0Gsz2HQhHY3tZJveDmvuKp3KcR7DckyIMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/shop/redirect.vue")
  },
  {
    name: "locale-returns",
    path: "/:locale()/returns",
    component: () => createClientPage(() => import("/vercel/path0/pages/[locale]/returns.client.vue"))
  },
  {
    name: "locale-shop-instagram",
    path: "/:locale()/shop/instagram",
    component: () => import("/vercel/path0/pages/[locale]/shop/instagram.vue")
  },
  {
    name: "locale-test-page",
    path: "/:locale()/test/:page(.*)*",
    meta: _91_46_46_46page_93aBT43oKTVErKa_5mHMXe7OvwKwZxIhjvwiK7g1jp3dIMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/test/[...page].vue")
  },
  {
    name: "locale-register-slug",
    path: "/:locale()/register/:slug()",
    meta: _91slug_93dFnL6vzNaTWgpQoJe8G5jjdQWdohcI5KdVI6RuPYDCgMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/register/[slug].vue")
  },
  {
    name: "locale-typeform-slug",
    path: "/:locale()/typeform/:slug()",
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "locale-account-dashboard",
    path: "/:locale()/account/dashboard",
    component: () => import("/vercel/path0/pages/[locale]/account/dashboard.vue"),
    children: [
  {
    name: "locale-account-dashboard-returns",
    path: "returns",
    component: () => import("/vercel/path0/pages/[locale]/account/dashboard/returns/index.vue")
  },
  {
    name: "locale-account-dashboard-orders-orderid",
    path: "orders/:orderid()",
    component: () => import("/vercel/path0/pages/[locale]/account/dashboard/orders/[orderid].vue")
  }
]
  },
  {
    name: "locale-discount-discount",
    path: "/:locale()/discount/:discount()",
    meta: _91discount_93g228A0zFklpDgOz1EpdDPVjq3Dei1nK0LA70DQy61P8Meta || {},
    component: () => import("/vercel/path0/pages/[locale]/discount/[discount].vue")
  },
  {
    name: "locale-checkout-prescription",
    path: "/:locale()/checkout/prescription",
    meta: prescriptionuc3bFinWw4rpEF5dOTQblxZ3r_e23WhgTNtt1r824CUMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/checkout/prescription.vue")
  },
  {
    name: "locale-shop-category",
    path: "/:locale()/shop/:category()",
    meta: indexUv9VkEPT7WUxH_4NG57wzE_1AhKGfJJsVk6zU7Ryeo8Meta || {},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/index.vue")
  },
  {
    name: "locale-explore-category",
    path: "/:locale()/explore/:category()",
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "locale-explore-category-article",
    path: "/:locale()/explore/:category()/:article()",
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/[article].vue")
  },
  {
    name: "locale-filter-page-filterpage",
    path: "/:locale()/filter-page/:filterpage(.*)*",
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "locale-shop-category-product",
    path: "/:locale()/shop/:category()/:product()",
    meta: index9YM3mwjYJIkLveeLLxnkPhDHDZxssi8_45jH9k4glA4XUMeta || {},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "locale-generic-landing-page-genericlandingpage",
    path: "/:locale()/generic-landing-page/:genericlandingpage(.*)*",
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "fp-ski-sunglasses-ski-sunglasses",
    path: "/:locale()/ski-sunglasses",
    meta: {"id":"AthaT7h7QBSezTwG7G_teg","slug":"ski-sunglasses","index":true,"title":"Ski Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ski-sunglasses","slugLocaleMapping":{"ski-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__goggles-shop__goggles",
    path: "/:locale()/shop/goggles",
    meta: {"id":"Lo6uf7h6R2CwZuFCQBP1Jw","slug":"shop__goggles","index":true,"title":"Ski & Snowboard Goggles | Performance Eyewear","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/goggles","slugLocaleMapping":{"shop__goggles":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sungod-early-access-sungod-early-access",
    path: "/:locale()/sungod-early-access",
    meta: {"id":"X2SyhGmRSA2XkbAwaRiltA","slug":"sungod-early-access","index":true,"title":"SunGod+ Exclusive Drops | Members-Only Early Access","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sungod-early-access","slugLocaleMapping":{"sungod-early-access":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-golf-sunglasses-golf-sunglasses",
    path: "/:locale()/golf-sunglasses",
    meta: {"id":"XSbrmnBVR6a2qoJXMwcqiA","slug":"golf-sunglasses","index":true,"title":"Polarised Golf Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/golf-sunglasses","slugLocaleMapping":{"golf-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-snowboard-goggles-snowboard-goggles",
    path: "/:locale()/snowboard-goggles",
    meta: {"id":"Lw_SAQnQQnKHJvZ9kJXbJA","slug":"snowboard-goggles","index":true,"title":"Athlete-Tested Goggles for Snowboarders","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/snowboard-goggles","slugLocaleMapping":{"snowboard-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-ski-goggles-ski-goggles",
    path: "/:locale()/ski-goggles",
    meta: {"id":"STKrgISTSh-r7ilfqFcArg","slug":"ski-goggles","index":true,"title":"Ski Goggles ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ski-goggles","slugLocaleMapping":{"ski-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-anti-fog-ski-and-snowboard-goggles-anti-fog-ski-and-snowboard-goggles",
    path: "/:locale()/anti-fog-ski-and-snowboard-goggles",
    meta: {"id":"HABMrDBqQhmcf7THqcAwJw","slug":"anti-fog-ski-and-snowboard-goggles","index":true,"title":"Anti-Fog Ski & Snowboard Goggles | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/anti-fog-ski-and-snowboard-goggles","slugLocaleMapping":{"anti-fog-ski-and-snowboard-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__limited-edition-shop__limited-edition",
    path: "/:locale()/shop/limited-edition",
    meta: {"id":"QXML7NAFRSOi7bBqJQwkHQ","slug":"shop__limited-edition","index":true,"title":"Limited Edition Sunglasses & Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/limited-edition","slugLocaleMapping":{"shop__limited-edition":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pace__performance-limited-edition-pace__performance-limited-edition",
    path: "/:locale()/pace/performance-limited-edition",
    meta: {"id":"bPceoyyVRMybizU_0znr2A","slug":"pace__performance-limited-edition","index":true,"title":"Limited Edition Performance Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pace/performance-limited-edition","slugLocaleMapping":{"pace__performance-limited-edition":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-snowboard-goggles-womens-snowboard-goggles",
    path: "/:locale()/womens-snowboard-goggles",
    meta: {"id":"ONLMAWH2R5earWm80qtOcA","slug":"womens-snowboard-goggles","index":true,"title":"Women's Snowboard Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-snowboard-goggles","slugLocaleMapping":{"womens-snowboard-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-snowboard-goggles-mens-snowboard-goggles",
    path: "/:locale()/mens-snowboard-goggles",
    meta: {"id":"cAba5YQ_QqST1AcHrzxpbQ","slug":"mens-snowboard-goggles","index":true,"title":"Men's Snowboard Goggles with Lifetime Guarantee","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-snowboard-goggles","slugLocaleMapping":{"mens-snowboard-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sale__running-sale__running",
    path: "/:locale()/sale/running",
    meta: {"id":"RQBBPuetRHe3vVzRXvJ80g","slug":"sale__running","index":true,"title":"Sale Running | up to 30% off | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sale/running","slugLocaleMapping":{"sale__running":["en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sale__cycling-sale__cycling",
    path: "/:locale()/sale/cycling",
    meta: {"id":"B8EhG2F5SM2jwTb05ItXHA","slug":"sale__cycling","index":true,"title":"Sale Cycling | up to 30% off | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sale/cycling","slugLocaleMapping":{"sale__cycling":["en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sale-sale",
    path: "/:locale()/sale",
    meta: {"id":"D7G9wH7SRLe8U2dZRKTafQ","slug":"sale","index":true,"title":"Sale | up to 30% off | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sale","slugLocaleMapping":{"sale":["en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-low-light-lens-sunglasses-low-light-lens-sunglasses",
    path: "/:locale()/low-light-lens-sunglasses",
    meta: {"id":"NrgikAU5ReuyQ0P9TSDOZQ","slug":"low-light-lens-sunglasses","index":true,"title":"Low Light Lens Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/low-light-lens-sunglasses","slugLocaleMapping":{"low-light-lens-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-green-ski-goggles-green-ski-goggles",
    path: "/:locale()/green-ski-goggles",
    meta: {"id":"cb0y52OUTleeGm4PWQP9BA","slug":"green-ski-goggles","index":true,"title":"Green Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/green-ski-goggles","slugLocaleMapping":{"green-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pink-ski-goggles-pink-ski-goggles",
    path: "/:locale()/pink-ski-goggles",
    meta: {"id":"ev-e-RVWSai1OPclCoQk1A","slug":"pink-ski-goggles","index":true,"title":"Pink Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pink-ski-goggles","slugLocaleMapping":{"pink-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-purple-ski-goggles-purple-ski-goggles",
    path: "/:locale()/purple-ski-goggles",
    meta: {"id":"Gn6RaWKoQFGnA4DNWhysxw","slug":"purple-ski-goggles","index":true,"title":"Purple Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/purple-ski-goggles","slugLocaleMapping":{"purple-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-orange-ski-goggles-orange-ski-goggles",
    path: "/:locale()/orange-ski-goggles",
    meta: {"id":"Cq2OQBCyQsOE2YOio2JPuQ","slug":"orange-ski-goggles","index":true,"title":"Orange Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/orange-ski-goggles","slugLocaleMapping":{"orange-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-blue-ski-goggles-blue-ski-goggles",
    path: "/:locale()/blue-ski-goggles",
    meta: {"id":"CxyC2QFbTE-ecEd-0O5hkw","slug":"blue-ski-goggles","index":true,"title":"Blue Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/blue-ski-goggles","slugLocaleMapping":{"blue-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-black-ski-goggles-black-ski-goggles",
    path: "/:locale()/black-ski-goggles",
    meta: {"id":"OKjQoqoMTOqHYVyHTLlgag","slug":"black-ski-goggles","index":true,"title":"Black Ski Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/black-ski-goggles","slugLocaleMapping":{"black-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-new-arrivals-new-arrivals",
    path: "/:locale()/new-arrivals",
    meta: {"id":"BIzL0plkRNCtNW64m4XzEg","slug":"new-arrivals","index":true,"title":"New In Sunglasses │ SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/new-arrivals","slugLocaleMapping":{"new-arrivals":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-photochromic-ski-goggles-photochromic-ski-goggles",
    path: "/:locale()/photochromic-ski-goggles",
    meta: {"id":"Y2Pc_19mQcSoUVttxORRFQ","slug":"photochromic-ski-goggles","index":true,"title":"Photochromic Ski Goggles | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/photochromic-ski-goggles","slugLocaleMapping":{"photochromic-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__pace-shop__pace",
    path: "/:locale()/shop/pace",
    meta: {"id":"b36WQ4wMSMObwkHS8JcPMQ","slug":"shop__pace","index":true,"title":"Performance Sunglasses | Pace Series™","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/pace","slugLocaleMapping":{"shop__pace":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-photochromic-performance-sunglasses-photochromic-performance-sunglasses",
    path: "/:locale()/photochromic-performance-sunglasses",
    meta: {"id":"aYhgQW2qTB-3Y59mb_MKnA","slug":"photochromic-performance-sunglasses","index":true,"title":"Iris™ Photochromic Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/photochromic-performance-sunglasses","slugLocaleMapping":{"photochromic-performance-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-black-sunglasses-black-sunglasses",
    path: "/:locale()/black-sunglasses",
    meta: {"id":"VYT90bHlSxmSDFQcQrvIsw","slug":"black-sunglasses","index":true,"title":"Black Lens & Frame Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/black-sunglasses","slugLocaleMapping":{"black-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-running-sunglasses-running-sunglasses",
    path: "/:locale()/running-sunglasses",
    meta: {"id":"D1Ac0e6CSd2_q8hPstSr2A","slug":"running-sunglasses","index":true,"title":"Running Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/running-sunglasses","slugLocaleMapping":{"running-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-plum-lens-sunglasses-plum-lens-sunglasses",
    path: "/:locale()/plum-lens-sunglasses",
    meta: {"id":"ZByS8q3BQ1K6sp0ns0TLGQ","slug":"plum-lens-sunglasses","index":true,"title":"Plum Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/plum-lens-sunglasses","slugLocaleMapping":{"plum-lens-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-everyday-sunglasses-everyday-sunglasses",
    path: "/:locale()/everyday-sunglasses",
    meta: {"id":"cUBx6fiRTX-Kg_4XuKuaLw","slug":"everyday-sunglasses","index":true,"title":"Everyday Sunglasses | 10+ Styles | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/everyday-sunglasses","slugLocaleMapping":{"everyday-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-trail-running-sunglasses-trail-running-sunglasses",
    path: "/:locale()/trail-running-sunglasses",
    meta: {"id":"S1QvilrMRAiPB7QAXswakA","slug":"trail-running-sunglasses","index":true,"title":"Trail Running Sunglasses | Ultra-Durable","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/trail-running-sunglasses","slugLocaleMapping":{"trail-running-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__custom-lifestyle-shop__custom-lifestyle",
    path: "/:locale()/shop/custom-lifestyle",
    meta: {"id":"Yl9ETsORTE2aqRLyYO60Yw","slug":"shop__custom-lifestyle","index":true,"title":"Custom Everyday Sunglasses | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/custom-lifestyle","slugLocaleMapping":{"shop__custom-lifestyle":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-custom-custom",
    path: "/:locale()/custom",
    meta: {"id":"epHdwzXCQ0yOZjwCBfC0hw","slug":"custom","index":true,"title":"Custom Sunglasses | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/custom","slugLocaleMapping":{"custom":["en-gb","en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-smoke-lens-sunglasses-smoke-lens-sunglasses",
    path: "/:locale()/smoke-lens-sunglasses",
    meta: {"id":"PUiisW4KQfuLHSiOaSZtMQ","slug":"smoke-lens-sunglasses","index":true,"title":"Smoke Lens Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/smoke-lens-sunglasses","slugLocaleMapping":{"smoke-lens-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-bestselling-sunglasses-bestselling-sunglasses",
    path: "/:locale()/bestselling-sunglasses",
    meta: {"id":"PLJ7f9L9SmKRq9r_ed87AQ","slug":"bestselling-sunglasses","index":true,"title":"Bestselling Sunglasses 2026","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/bestselling-sunglasses","slugLocaleMapping":{"bestselling-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-blue-sunglasses-blue-sunglasses",
    path: "/:locale()/blue-sunglasses",
    meta: {"id":"PBLRdjdiSGiI_24_KPrpkA","slug":"blue-sunglasses","index":true,"title":"Blue Lens & Frame Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/blue-sunglasses","slugLocaleMapping":{"blue-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-custom__performance-custom__performance",
    path: "/:locale()/custom/performance",
    meta: {"id":"Z-6p8eVoSICagoetCcuW9g","slug":"custom__performance","index":true,"title":"Custom Performance Eyewear","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/custom/performance","slugLocaleMapping":{"custom__performance":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-running-sunglasses-womens-running-sunglasses",
    path: "/:locale()/womens-running-sunglasses",
    meta: {"id":"YI15u15aTA6Zg-PgImfAiw","slug":"womens-running-sunglasses","index":true,"title":"Women's Running Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-running-sunglasses","slugLocaleMapping":{"womens-running-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-all-womens-sunglasses-all-womens-sunglasses",
    path: "/:locale()/all-womens-sunglasses",
    meta: {"id":"CHH42IzhTUayiBD48weKzw","slug":"all-womens-sunglasses","index":true,"title":"Women's Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/all-womens-sunglasses","slugLocaleMapping":{"all-womens-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-all-mens-sunglasses-all-mens-sunglasses",
    path: "/:locale()/all-mens-sunglasses",
    meta: {"id":"cLEtT1xOS02Q__QmP0oQ7Q","slug":"all-mens-sunglasses","index":true,"title":"Men's Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/all-mens-sunglasses","slugLocaleMapping":{"all-mens-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-polarised-sunglasses-polarised-sunglasses",
    path: "/:locale()/polarised-sunglasses",
    meta: {"id":"E-29V6AJTNOIfkVQb4j6ew","slug":"polarised-sunglasses","index":true,"title":"Polarised Sunglasses | 8KO® Lenses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/polarised-sunglasses","slugLocaleMapping":{"polarised-sunglasses":["en-gb","en-gb","en-nz"],"polarized-sunglasses":["en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-polarised-sunglasses-polarized-sunglasses",
    path: "/:locale()/polarized-sunglasses",
    meta: {"id":"E-29V6AJTNOIfkVQb4j6ew","slug":"polarized-sunglasses","index":true,"title":"Polarised Sunglasses | 8KO® Lenses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/polarised-sunglasses","slugLocaleMapping":{"polarised-sunglasses":["en-gb","en-gb","en-nz"],"polarized-sunglasses":["en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-green-sunglasses-green-sunglasses",
    path: "/:locale()/green-sunglasses",
    meta: {"id":"ICtjbiOQSpG_rkfl0m-P5A","slug":"green-sunglasses","index":true,"title":"Green Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/green-sunglasses","slugLocaleMapping":{"green-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sand-sunglasses-sand-sunglasses",
    path: "/:locale()/sand-sunglasses",
    meta: {"id":"eOX6W43WR8Cr7HJ9gaHs0g","slug":"sand-sunglasses","index":true,"title":"Sand Frame Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sand-sunglasses","slugLocaleMapping":{"sand-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-orange-sunglasses-orange-sunglasses",
    path: "/:locale()/orange-sunglasses",
    meta: {"id":"ZzsGJ19QR9y95UR_R0ZDNw","slug":"orange-sunglasses","index":true,"title":"Orange Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/orange-sunglasses","slugLocaleMapping":{"orange-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-limited-edition-goggles-limited-edition-goggles",
    path: "/:locale()/limited-edition-goggles",
    meta: {"id":"PcmRMiTTSii3qHdiuNN1ZQ","slug":"limited-edition-goggles","index":true,"title":"Limited Edition Ski & Snowboard Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/limited-edition-goggles","slugLocaleMapping":{"limited-edition-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-clear-sunglasses-clear-sunglasses",
    path: "/:locale()/clear-sunglasses",
    meta: {"id":"aKIMMyW2RcCpCgCtm0ojpA","slug":"clear-sunglasses","index":true,"title":"Clear Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/clear-sunglasses","slugLocaleMapping":{"clear-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-running-sunglasses-mens-running-sunglasses",
    path: "/:locale()/mens-running-sunglasses",
    meta: {"id":"RbqWEON0QEaCCjr1B8c7FQ","slug":"mens-running-sunglasses","index":true,"title":"Men's Road & Trail Running Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-running-sunglasses","slugLocaleMapping":{"mens-running-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-gravel-bike-sunglasses-gravel-bike-sunglasses",
    path: "/:locale()/gravel-bike-sunglasses",
    meta: {"id":"I5nunaaLSRCNhJ0MFiwp3A","slug":"gravel-bike-sunglasses","index":true,"title":"Durable Gravel Bike Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/gravel-bike-sunglasses","slugLocaleMapping":{"gravel-bike-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pickleball-sunglasses-pickleball-sunglasses",
    path: "/:locale()/pickleball-sunglasses",
    meta: {"id":"WiwqqGFxQrenBvDP6YqMOQ","slug":"pickleball-sunglasses","index":true,"title":"Pickleball Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pickleball-sunglasses","slugLocaleMapping":{"pickleball-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-cricket-sunglasses-cricket-sunglasses",
    path: "/:locale()/cricket-sunglasses",
    meta: {"id":"EOYaatG3SzyUG8g6komQTA","slug":"cricket-sunglasses","index":true,"title":"Cricket Sunglasses | Official England Cricket","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/cricket-sunglasses","slugLocaleMapping":{"cricket-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-baseball-sunglasses-baseball-sunglasses",
    path: "/:locale()/baseball-sunglasses",
    meta: {"id":"BBDnC-wDQ0iDJmGKlNrGSA","slug":"baseball-sunglasses","index":true,"title":"Baseball Sunglasses | Official MLB Eyewear","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/baseball-sunglasses","slugLocaleMapping":{"baseball-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-ironman-sunglasses-ironman-sunglasses",
    path: "/:locale()/ironman-sunglasses",
    meta: {"id":"YOa9aNh2TlqJFU79L9nC_A","slug":"ironman-sunglasses","index":true,"title":"Ironman Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ironman-sunglasses","slugLocaleMapping":{"ironman-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-gold-sunglasses-gold-sunglasses",
    path: "/:locale()/gold-sunglasses",
    meta: {"id":"JRTN_tR8Sj2jFlXP3OTcIA","slug":"gold-sunglasses","index":true,"title":"Gold Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/gold-sunglasses","slugLocaleMapping":{"gold-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-ineos-grenadiers__all-ineos-grenadiers__all",
    path: "/:locale()/ineos-grenadiers/all",
    meta: {"id":"Hgg7SMWQRLS036m9fwjEJw","slug":"ineos-grenadiers__all","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ineos-grenadiers/all","slugLocaleMapping":{"ineos-grenadiers__all":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-brown-sunglasses-brown-sunglasses",
    path: "/:locale()/brown-sunglasses",
    meta: {"id":"abBKKdpgTnm1yBhjDuyNoA","slug":"brown-sunglasses","index":true,"title":"Brown Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/brown-sunglasses","slugLocaleMapping":{"brown-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-surf-sunglasses-surf-sunglasses",
    path: "/:locale()/surf-sunglasses",
    meta: {"id":"a4ucZeoWS5GdWz4OdJtAtw","slug":"surf-sunglasses","index":true,"title":"Surf Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/surf-sunglasses","slugLocaleMapping":{"surf-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-kitesurf-sunglasses-kitesurf-sunglasses",
    path: "/:locale()/kitesurf-sunglasses",
    meta: {"id":"ChWytrhMQo6UvQspmeDTEg","slug":"kitesurf-sunglasses","index":true,"title":"Kitesurfing Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/kitesurf-sunglasses","slugLocaleMapping":{"kitesurf-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-kayak-sunglasses-kayak-sunglasses",
    path: "/:locale()/kayak-sunglasses",
    meta: {"id":"S-hRcJFESTqVRJVHHCoUog","slug":"kayak-sunglasses","index":true,"title":"Kayak Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/kayak-sunglasses","slugLocaleMapping":{"kayak-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-canoe-sunglasses-canoe-sunglasses",
    path: "/:locale()/canoe-sunglasses",
    meta: {"id":"Mp-hCnEYQtmejKMh-rQ6kQ","slug":"canoe-sunglasses","index":true,"title":"Canoe Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/canoe-sunglasses","slugLocaleMapping":{"canoe-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pink-sunglasses-pink-sunglasses",
    path: "/:locale()/pink-sunglasses",
    meta: {"id":"BK1gLephS4WdSwd15h5Cvw","slug":"pink-sunglasses","index":true,"title":"Pink Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pink-sunglasses","slugLocaleMapping":{"pink-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-horse-riding-sunglasses-horse-riding-sunglasses",
    path: "/:locale()/horse-riding-sunglasses",
    meta: {"id":"FijNzatXTde2LUf0xY9xyQ","slug":"horse-riding-sunglasses","index":true,"title":"Horse Riding Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/horse-riding-sunglasses","slugLocaleMapping":{"horse-riding-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__sunglasses-shop__sunglasses",
    path: "/:locale()/shop/sunglasses",
    meta: {"id":"OoMqSBLQT-2p2stB20BuFw","slug":"shop__sunglasses","index":true,"title":"Award-Winning Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/sunglasses","slugLocaleMapping":{"shop__sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-driving-sunglasses-driving-sunglasses",
    path: "/:locale()/driving-sunglasses",
    meta: {"id":"dnhRcmHlT7SIUMZubRhi-g","slug":"driving-sunglasses","index":true,"title":"Driving Sunglasses | UK Road Legal Lenses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/driving-sunglasses","slugLocaleMapping":{"driving-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-biathlon-sunglasses-biathlon-sunglasses",
    path: "/:locale()/biathlon-sunglasses",
    meta: {"id":"NJjL0ASDTAC-Yl9zP95IGQ","slug":"biathlon-sunglasses","index":true,"title":"Biathlon Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/biathlon-sunglasses","slugLocaleMapping":{"biathlon-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-skateboard-sunglasses-skateboard-sunglasses",
    path: "/:locale()/skateboard-sunglasses",
    meta: {"id":"C3ne_TQ2RqG7w7sFp2hzjw","slug":"skateboard-sunglasses","index":true,"title":"Skateboard Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/skateboard-sunglasses","slugLocaleMapping":{"skateboard-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-archery-sunglasses-archery-sunglasses",
    path: "/:locale()/archery-sunglasses",
    meta: {"id":"BnE24QbgT62-wdTpOXAPeA","slug":"archery-sunglasses","index":true,"title":"Archery Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/archery-sunglasses","slugLocaleMapping":{"archery-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-lacrosse-sunglasses-lacrosse-sunglasses",
    path: "/:locale()/lacrosse-sunglasses",
    meta: {"id":"T6wZkpH5RRGNgHgq0uO4hg","slug":"lacrosse-sunglasses","index":true,"title":"Lacrosse Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/lacrosse-sunglasses","slugLocaleMapping":{"lacrosse-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-equestrian-sunglasses-equestrian-sunglasses",
    path: "/:locale()/equestrian-sunglasses",
    meta: {"id":"KxfSEj3uSHGsZP5Pv4sEYg","slug":"equestrian-sunglasses","index":true,"title":"Equestrian Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/equestrian-sunglasses","slugLocaleMapping":{"equestrian-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-beach-volleyball-sunglasses-beach-volleyball-sunglasses",
    path: "/:locale()/beach-volleyball-sunglasses",
    meta: {"id":"X8WDFIG7QCyTMpb18p51uQ","slug":"beach-volleyball-sunglasses","index":true,"title":"Beach Volleyball Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/beach-volleyball-sunglasses","slugLocaleMapping":{"beach-volleyball-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-padel-sunglasses-padel-sunglasses",
    path: "/:locale()/padel-sunglasses",
    meta: {"id":"ZdAAfs9QQJqKDnFuxlhRCg","slug":"padel-sunglasses","index":true,"title":"Padel Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/padel-sunglasses","slugLocaleMapping":{"padel-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-windsurfing-sunglasses-windsurfing-sunglasses",
    path: "/:locale()/windsurfing-sunglasses",
    meta: {"id":"IgKE-Fw1TCeRoLxuid96kg","slug":"windsurfing-sunglasses","index":true,"title":"Windsurfing Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/windsurfing-sunglasses","slugLocaleMapping":{"windsurfing-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-paddle-board-sunglasses-paddle-board-sunglasses",
    path: "/:locale()/paddle-board-sunglasses",
    meta: {"id":"cf5fIeMLQfKG75BHWyC9gw","slug":"paddle-board-sunglasses","index":true,"title":"Paddle Board Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/paddle-board-sunglasses","slugLocaleMapping":{"paddle-board-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-winter-sunglasses-winter-sunglasses",
    path: "/:locale()/winter-sunglasses",
    meta: {"id":"Db2GX7ZRT1a3jaFw77tjCQ","slug":"winter-sunglasses","index":true,"title":"Winter Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/winter-sunglasses","slugLocaleMapping":{"winter-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-marathon-sunglasses-marathon-sunglasses",
    path: "/:locale()/marathon-sunglasses",
    meta: {"id":"Mpn61BeUTGSbtAOSu0QmNw","slug":"marathon-sunglasses","index":true,"title":"Marathon Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/marathon-sunglasses","slugLocaleMapping":{"marathon-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-for-large-faces-sunglasses-for-large-faces",
    path: "/:locale()/sunglasses-for-large-faces",
    meta: {"id":"VkRTN2vnQXStiScJje8aPw","slug":"sunglasses-for-large-faces","index":true,"title":"Sunglasses for Larger Faces","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-for-large-faces","slugLocaleMapping":{"sunglasses-for-large-faces":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-for-oval-faces-sunglasses-for-oval-faces",
    path: "/:locale()/sunglasses-for-oval-faces",
    meta: {"id":"Nhx9GL1kRACvCscp2GNajA","slug":"sunglasses-for-oval-faces","index":true,"title":"Sunglasses for Oval Faces","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-for-oval-faces","slugLocaleMapping":{"sunglasses-for-oval-faces":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-visor-sunglasses-visor-sunglasses",
    path: "/:locale()/visor-sunglasses",
    meta: {"id":"ZJ9EAakkQwGCc_jsrSYzfA","slug":"visor-sunglasses","index":true,"title":"Visor Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/visor-sunglasses","slugLocaleMapping":{"visor-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shield-sunglasses-shield-sunglasses",
    path: "/:locale()/shield-sunglasses",
    meta: {"id":"LI-PJDNVQZ27K86qGC58HA","slug":"shield-sunglasses","index":true,"title":"Shield Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shield-sunglasses","slugLocaleMapping":{"shield-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-purple-sunglasses-purple-sunglasses",
    path: "/:locale()/purple-sunglasses",
    meta: {"id":"CB98kbvSQkGogm9-Fmx-OA","slug":"purple-sunglasses","index":true,"title":"Purple Lens Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/purple-sunglasses","slugLocaleMapping":{"purple-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-sunglasses-mens-sunglasses",
    path: "/:locale()/mens-sunglasses",
    meta: {"id":"NmMdtJmYTM-dcz68Dtt6HQ","slug":"mens-sunglasses","index":true,"title":"Men's Everyday Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-sunglasses","slugLocaleMapping":{"mens-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-cycling-sunglasses-womens-cycling-sunglasses",
    path: "/:locale()/womens-cycling-sunglasses",
    meta: {"id":"AK794cikSzunes8FrzOedg","slug":"womens-cycling-sunglasses","index":true,"title":"Women's Cycling Sunglasses | Durable & Lightweight","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-cycling-sunglasses","slugLocaleMapping":{"womens-cycling-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-cycling-sunglasses-mens-cycling-sunglasses",
    path: "/:locale()/mens-cycling-sunglasses",
    meta: {"id":"CHAJjngGSFyrAio4fQbPAg","slug":"mens-cycling-sunglasses","index":true,"title":"Men's Cycling Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-cycling-sunglasses","slugLocaleMapping":{"mens-cycling-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-cycling-sunglasses-cycling-sunglasses",
    path: "/:locale()/cycling-sunglasses",
    meta: {"id":"K1bxCC1kQG-C1eohDRpX-w","slug":"cycling-sunglasses","index":true,"title":"Cycling Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/cycling-sunglasses","slugLocaleMapping":{"cycling-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pace__mens-pace__mens",
    path: "/:locale()/pace/mens",
    meta: {"id":"C0icLGmrRRWtVrLPSJT4lA","slug":"pace__mens","index":true,"title":"Men's Performance Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pace/mens","slugLocaleMapping":{"pace__mens":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-lifestyle-8ko-polarised-lifestyle-8ko-polarised",
    path: "/:locale()/lifestyle-8ko-polarised",
    meta: {"id":"Sc-xOE9MQe-5vXpLLqoIjA","slug":"lifestyle-8ko-polarised","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/lifestyle-8ko-polarised","slugLocaleMapping":{"lifestyle-8ko-polarised":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-8kop-and-iris-lens-tech-sunglasses-8kop-and-iris-lens-tech-sunglasses",
    path: "/:locale()/8kop-and-iris-lens-tech-sunglasses",
    meta: {"id":"SV9Y8gcDQi2-F8s6tf6upA","slug":"8kop-and-iris-lens-tech-sunglasses","index":true,"title":"8KO® & Iris™ Lens Tech Sunglasses | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/8kop-and-iris-lens-tech-sunglasses","slugLocaleMapping":{"8kop-and-iris-lens-tech-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-road-cycling-sunglasses-road-cycling-sunglasses",
    path: "/:locale()/road-cycling-sunglasses",
    meta: {"id":"SJzlkf_cSGiMjFYXokLFyg","slug":"road-cycling-sunglasses","index":true,"title":"Road Cycling Sunglasses | Hydrophobic Lenses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/road-cycling-sunglasses","slugLocaleMapping":{"road-cycling-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__all-shop__all",
    path: "/:locale()/shop/all",
    meta: {"id":"MipZrn63QvunjF0TkbwwSQ","slug":"shop__all","index":true,"title":"All Sunglasses & Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/all","slugLocaleMapping":{"shop__all":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-bundles-bundles",
    path: "/:locale()/bundles",
    meta: {"id":"GCpkp2LsRHujKjrt8eh7qQ","slug":"bundles","index":true,"title":"Race & Rest Bundles | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/bundles","slugLocaleMapping":{"bundles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-sunglasses-womens-sunglasses",
    path: "/:locale()/womens-sunglasses",
    meta: {"id":"FPPK7GyYTLqA9cDAr4ScXg","slug":"womens-sunglasses","index":true,"title":"Women's Everyday Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-sunglasses","slugLocaleMapping":{"womens-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-new-colours-new-colours",
    path: "/:locale()/new-colours",
    meta: {"id":"CDYm_esfQ02rWgjIpDuVcw","slug":"new-colours","index":true,"title":"New Colour Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/new-colours","slugLocaleMapping":{"new-colours":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-desert-sand-sunglasses-desert-sand-sunglasses",
    path: "/:locale()/desert-sand-sunglasses",
    meta: {"id":"Pzd9FpWCQGuAJWcMRkslpQ","slug":"desert-sand-sunglasses","index":true,"title":"Desert Sand Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/desert-sand-sunglasses","slugLocaleMapping":{"desert-sand-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__lifestyle-shop__lifestyle",
    path: "/:locale()/shop/lifestyle",
    meta: {"id":"IpiceQ9YQGqSAdSnfnN0MQ","slug":"shop__lifestyle","index":true,"title":"Daily Lifestyle Sunglasses | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/lifestyle","slugLocaleMapping":{"shop__lifestyle":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pace__womens-pace__womens",
    path: "/:locale()/pace/womens",
    meta: {"id":"Yh7VGsjuT3KfNEpKs9wX3g","slug":"pace__womens","index":true,"title":"Women's Performance Sunglasses | Pace Series™","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pace/womens","slugLocaleMapping":{"pace__womens":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-ski-goggles-womens-ski-goggles",
    path: "/:locale()/womens-ski-goggles",
    meta: {"id":"Kt_ehTscRraEanhT4gPkNw","slug":"womens-ski-goggles","index":true,"title":"Women’s Ski Goggles | Low Light & Anti-Fog ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-ski-goggles","slugLocaleMapping":{"womens-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-goggles-mens-goggles",
    path: "/:locale()/mens-goggles",
    meta: {"id":"M2BDhGouSgiXaSDMcXsyGg","slug":"mens-goggles","index":true,"title":"Men's Ski & Snowboard Goggles with 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-goggles","slugLocaleMapping":{"mens-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-snow-goggles-snow-goggles",
    path: "/:locale()/snow-goggles",
    meta: {"id":"QUC63xG1SEKiaFuY3W-ebw","slug":"snow-goggles","index":true,"title":"Snow Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/snow-goggles","slugLocaleMapping":{"snow-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-wraparound-sunglasses-wraparound-sunglasses",
    path: "/:locale()/wraparound-sunglasses",
    meta: {"id":"XnxAXiziSO-ddrOVHcbH7A","slug":"wraparound-sunglasses","index":true,"title":"Wraparound Sunglasses | ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/wraparound-sunglasses","slugLocaleMapping":{"wraparound-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mountaineering-sunglasses-mountaineering-sunglasses",
    path: "/:locale()/mountaineering-sunglasses",
    meta: {"id":"adKUKEJpS5yFUloZmhrfCg","slug":"mountaineering-sunglasses","index":true,"title":"Mountaineering Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mountaineering-sunglasses","slugLocaleMapping":{"mountaineering-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-hiking-sunglasses-hiking-sunglasses",
    path: "/:locale()/hiking-sunglasses",
    meta: {"id":"P7m2OhBXS7ely_ievDxXTw","slug":"hiking-sunglasses","index":true,"title":"Hiking Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/hiking-sunglasses","slugLocaleMapping":{"hiking-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mountain-biking-sunglasses-mountain-biking-sunglasses",
    path: "/:locale()/mountain-biking-sunglasses",
    meta: {"id":"BcdxVcJ9S56UF6UoHFdw_w","slug":"mountain-biking-sunglasses","index":true,"title":"Mountain Biking Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mountain-biking-sunglasses","slugLocaleMapping":{"mountain-biking-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mountain-biking-goggles-mountain-biking-goggles",
    path: "/:locale()/mountain-biking-goggles",
    meta: {"id":"Y0LQs06VQgGphm4ee3N1Dw","slug":"mountain-biking-goggles","index":true,"title":"Mountain Biking Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mountain-biking-goggles","slugLocaleMapping":{"mountain-biking-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-custom-goggles-custom-goggles",
    path: "/:locale()/custom-goggles",
    meta: {"id":"IdpBrCRpSlGGi1Agw03jSA","slug":"custom-goggles","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/custom-goggles","slugLocaleMapping":{"custom-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mclaren__all-mclaren__all",
    path: "/:locale()/mclaren/all",
    meta: {"id":"bBBdmTiPSGCVDSvICLg09g","slug":"mclaren__all","index":true,"title":"Official McLaren F1 Sunglasses: 2026","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mclaren/all","slugLocaleMapping":{"mclaren__all":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-tortoiseshell-sunglasses-tortoiseshell-sunglasses",
    path: "/:locale()/tortoiseshell-sunglasses",
    meta: {"id":"Z-WoTI1FSF-6gTWbIHuu0Q","slug":"tortoiseshell-sunglasses","index":true,"title":"Tortoiseshell Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/tortoiseshell-sunglasses","slugLocaleMapping":{"tortoiseshell-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-navy-sunglasses-navy-sunglasses",
    path: "/:locale()/navy-sunglasses",
    meta: {"id":"DoiHy50_QpS5YKbhvkH_cg","slug":"navy-sunglasses","index":true,"title":"Navy Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/navy-sunglasses","slugLocaleMapping":{"navy-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-white-sunglasses-white-sunglasses",
    path: "/:locale()/white-sunglasses",
    meta: {"id":"OSu1G2LFT6KJZ5E1FCP-Eg","slug":"white-sunglasses","index":true,"title":"White Sunglasses | SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/white-sunglasses","slugLocaleMapping":{"white-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-fishing-sunglasses-fishing-sunglasses",
    path: "/:locale()/fishing-sunglasses",
    meta: {"id":"VsBWmMr0R4GcDmI8DIpRkQ","slug":"fishing-sunglasses","index":true,"title":"Polarised Fishing Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/fishing-sunglasses","slugLocaleMapping":{"fishing-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sports-sunglasses-sports-sunglasses",
    path: "/:locale()/sports-sunglasses",
    meta: {"id":"YTa2DaNtQHG0g4DPbC4TPA","slug":"sports-sunglasses","index":true,"title":"Polarised Sports Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sports-sunglasses","slugLocaleMapping":{"sports-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-goggle-accessories-goggle-accessories",
    path: "/:locale()/goggle-accessories",
    meta: {"id":"K3SEfzU0QoW736yTGfmrew","slug":"goggle-accessories","index":true,"title":null,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/goggle-accessories","slugLocaleMapping":{"goggle-accessories":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-accessories-sunglasses-accessories",
    path: "/:locale()/sunglasses-accessories",
    meta: {"id":"NLK7EziPRTq5lfJNKhhMVw","slug":"sunglasses-accessories","index":true,"title":"Sunglasses Accessories","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-accessories","slugLocaleMapping":{"sunglasses-accessories":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__aurora-shop__aurora",
    path: "/:locale()/shop/aurora",
    meta: {"id":"QOX-qvreQyS0S9uBi3LkOA","slug":"shop__aurora","index":true,"title":"Aurora | New for 2026","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/aurora","slugLocaleMapping":{"shop__aurora":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-forty2stm-forty2stm",
    path: "/:locale()/forty2stm",
    meta: {"id":"fBrgseY8QaC-xrZBtW8a2Q","slug":"forty2stm","index":true,"title":"SunGod FORTY2s™ | For Runners","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/forty2stm","slugLocaleMapping":{"forty2stm":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-ski-gifts-ski-gifts",
    path: "/:locale()/ski-gifts",
    meta: {"id":"I9K7r92bQXejN6RJC07SdA","slug":"ski-gifts","index":true,"title":"Gifts for Skiers","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ski-gifts","slugLocaleMapping":{"ski-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-cricket-gifts-cricket-gifts",
    path: "/:locale()/cricket-gifts",
    meta: {"id":"Ng5cDmB7QTytE12pqAVXqQ","slug":"cricket-gifts","index":true,"title":"Cricket Gifts","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/cricket-gifts","slugLocaleMapping":{"cricket-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-f1-gifts-f1-gifts",
    path: "/:locale()/f1-gifts",
    meta: {"id":"dZVTfafcS4WLXmfItIG-6A","slug":"f1-gifts","index":true,"title":"Gifts for F1 Fans","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/f1-gifts","slugLocaleMapping":{"f1-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-golf-gifts-golf-gifts",
    path: "/:locale()/golf-gifts",
    meta: {"id":"OtGrLEvLT_GbehZR3PJvRA","slug":"golf-gifts","index":true,"title":"Gifts for Golfers","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/golf-gifts","slugLocaleMapping":{"golf-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-running-gifts-running-gifts",
    path: "/:locale()/running-gifts",
    meta: {"id":"EMu-DsC2Sg2LCGy8aW9kwg","slug":"running-gifts","index":true,"title":"Gifts for Runners 2026","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/running-gifts","slugLocaleMapping":{"running-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-cycling-gifts-cycling-gifts",
    path: "/:locale()/cycling-gifts",
    meta: {"id":"UrJ3wvUcShC4tvBJtN3tBg","slug":"cycling-gifts","index":true,"title":"Gifts for Cyclists 2026","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/cycling-gifts","slugLocaleMapping":{"cycling-gifts":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-prescription-glasses-prescription-glasses",
    path: "/:locale()/prescription-glasses",
    meta: {"id":"Gb6uuf5GRj-jZm--1QB7Hw","slug":"prescription-glasses","index":true,"title":"Prescription Glasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/prescription-glasses","slugLocaleMapping":{"prescription-glasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__prescription-sunglasses-shop__prescription-sunglasses",
    path: "/:locale()/shop/prescription-sunglasses",
    meta: {"id":"Bw3ihGHRR5O2JEizG2kv1Q","slug":"shop__prescription-sunglasses","index":true,"title":"Prescription Sunglasses | -8 to +6","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/prescription-sunglasses","slugLocaleMapping":{"shop__prescription-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-bundles__pace-bundles__pace",
    path: "/:locale()/bundles/pace",
    meta: {"id":"YWktZZFKQYGCrBFHJhIrAg","slug":"bundles__pace","index":true,"title":"Pace Performance Eyewear Bundle","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/bundles/pace","slugLocaleMapping":{"bundles__pace":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-archive-goggles-archive-goggles",
    path: "/:locale()/archive-goggles",
    meta: {"id":"fVPFsBaDTMWJnjKQ6lNGGg","slug":"archive-goggles","index":true,"title":"SunGod Archive Goggles | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/archive-goggles","slugLocaleMapping":{"archive-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-softball-sunglasses-softball-sunglasses",
    path: "/:locale()/softball-sunglasses",
    meta: {"id":"RFsoXkrTQO6xRnzRmwr55A","slug":"softball-sunglasses","index":true,"title":"Softball Sunglasses | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/softball-sunglasses","slugLocaleMapping":{"softball-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-8ko-lifestyle-sunglasses-8ko-lifestyle-sunglasses",
    path: "/:locale()/8ko-lifestyle-sunglasses",
    meta: {"id":"SLTNJ1FFTG6Tz19CnByqvg","slug":"8ko-lifestyle-sunglasses","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/8ko-lifestyle-sunglasses","slugLocaleMapping":{"8ko-lifestyle-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-8ko-lifestyle-and-performance-sunglasses-8ko-lifestyle-and-performance-sunglasses",
    path: "/:locale()/8ko-lifestyle-and-performance-sunglasses",
    meta: {"id":"MzQzRltpSOeEEPbpDp529g","slug":"8ko-lifestyle-and-performance-sunglasses","index":true,"title":"8KO® Sunglasses from SunGod","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/8ko-lifestyle-and-performance-sunglasses","slugLocaleMapping":{"8ko-lifestyle-and-performance-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-road-running-sunglasses-road-running-sunglasses",
    path: "/:locale()/road-running-sunglasses",
    meta: {"id":"Vg9BwmOqTUiHGf0PTbth8Q","slug":"road-running-sunglasses","index":true,"title":"Road Running Sunglasses | Ultra-Lightweight","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/road-running-sunglasses","slugLocaleMapping":{"road-running-sunglasses":["en-gb","en-gb","en-nz","en-us","en-au","en-ca","en-ch","en-eu"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-archive-archive",
    path: "/:locale()/archive",
    meta: {"id":"CTwW516lRfuuspI5rYeAsQ","slug":"archive","index":true,"title":"SunGod Archive | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/archive","slugLocaleMapping":{"archive":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-f1-sunglasses-f1-sunglasses",
    path: "/:locale()/f1-sunglasses",
    meta: {"id":"QNM-o3DWSI2BVQm_snFryg","slug":"f1-sunglasses","index":true,"title":"F1 Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/f1-sunglasses","slugLocaleMapping":{"f1-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-watersports-sunglasses-watersports-sunglasses",
    path: "/:locale()/watersports-sunglasses",
    meta: {"id":"CV4M02IZQY-1AXVoZt9qPg","slug":"watersports-sunglasses","index":true,"title":"Polarised Watersports Sunglasses | Hydrophobic","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/watersports-sunglasses","slugLocaleMapping":{"watersports-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-triathlon-sunglasses-triathlon-sunglasses",
    path: "/:locale()/triathlon-sunglasses",
    meta: {"id":"bjL6STg-RMm05z4QvM8Qfw","slug":"triathlon-sunglasses","index":true,"title":"Polarised Triathlon Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/triathlon-sunglasses","slugLocaleMapping":{"triathlon-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-tennis-sunglasses-tennis-sunglasses",
    path: "/:locale()/tennis-sunglasses",
    meta: {"id":"WchOOw5uRuum00EnLxxbIw","slug":"tennis-sunglasses","index":true,"title":"Polarised Tennis Sunglasses | 100% UV Protection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/tennis-sunglasses","slugLocaleMapping":{"tennis-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sailing-sunglasses-sailing-sunglasses",
    path: "/:locale()/sailing-sunglasses",
    meta: {"id":"Z_6M0BD2SSeRfWca7CCjsQ","slug":"sailing-sunglasses","index":true,"title":"Polarised Sailing Sunglasses","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sailing-sunglasses","slugLocaleMapping":{"sailing-sunglasses":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-rowing-sunglasses-rowing-sunglasses",
    path: "/:locale()/rowing-sunglasses",
    meta: {"id":"a2mhQ7ksTxKBRX85ikymzA","slug":"rowing-sunglasses","index":true,"title":"Polarised Rowing Sunglasses ","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/rowing-sunglasses","slugLocaleMapping":{"rowing-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-protect-our-winters-uk-protect-our-winters-uk",
    path: "/:locale()/protect-our-winters-uk",
    meta: {"id":"cWFe4wbeQ-ygxW0ZKNGiOg","slug":"protect-our-winters-uk","index":true,"title":"Ski Goggles from Protect Our Winters UK","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/protect-our-winters-uk","slugLocaleMapping":{"protect-our-winters-uk":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__accessories-shop__accessories",
    path: "/:locale()/shop/accessories",
    meta: {"id":"T1yL97j9RnusiDvJvqOX3g","slug":"shop__accessories","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/accessories","slugLocaleMapping":{"shop__accessories":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mclaren__oscar-piastri-mclaren__oscar-piastri",
    path: "/:locale()/mclaren/oscar-piastri",
    meta: {"id":"C5LVeLfgSFC2a7vkAx_qtw","slug":"mclaren__oscar-piastri","index":true,"title":"McLaren F1 Team Sunglasses: Oscar Piastri Collection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mclaren/oscar-piastri","slugLocaleMapping":{"mclaren__oscar-piastri":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__lando-norris-shop__lando-norris",
    path: "/:locale()/shop/lando-norris",
    meta: {"id":"FLQlOnLMSRClBxCz5gAApQ","slug":"shop__lando-norris","index":true,"title":"McLaren F1 Team Sunglasses: Lando Norris Collection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/lando-norris","slugLocaleMapping":{"shop__lando-norris":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sungod-x-new-era-sungod-x-new-era",
    path: "/:locale()/sungod-x-new-era",
    meta: {"id":"DhogMTrtT8-d2Ax6mFkKTA","slug":"sungod-x-new-era","index":true,"title":"SunGod x New Era: Limited Edition Headwear Collection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sungod-x-new-era","slugLocaleMapping":{"sungod-x-new-era":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-summer-solstice-summer-solstice",
    path: "/:locale()/summer-solstice",
    meta: {"id":"a356UUB5TNSb_yZkZCqfow","slug":"summer-solstice","index":true,"title":"SunGod Solstice Collection","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/summer-solstice","slugLocaleMapping":{"summer-solstice":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-latest-launches-latest-launches",
    path: "/:locale()/latest-launches",
    meta: {"id":"XuM9ad_bQtONI7InLQQdzA","slug":"latest-launches","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/latest-launches","slugLocaleMapping":{"latest-launches":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-prescription-glasses-and-sunglasses-prescription-glasses-and-sunglasses",
    path: "/:locale()/prescription-glasses-and-sunglasses",
    meta: {"id":"Sgv9JT7VRaKOnoLE1uf23A","slug":"prescription-glasses-and-sunglasses","index":true,"title":"Prescription Sunglasses & Glasses | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/prescription-glasses-and-sunglasses","slugLocaleMapping":{"prescription-glasses-and-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__custom-prescription-shop__custom-prescription",
    path: "/:locale()/shop/custom-prescription",
    meta: {"id":"HA-sOtn2Q8iLdKtP6IvEaw","slug":"shop__custom-prescription","index":true,"title":"Custom Prescription Sunglasses | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/custom-prescription","slugLocaleMapping":{"shop__custom-prescription":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-desert-sand__all-desert-sand__all",
    path: "/:locale()/desert-sand/all",
    meta: {"id":"UX0JvJrITfahFS_oayE6pQ","slug":"desert-sand__all","index":true,"title":"Desert Sand Sunglasses │ SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/desert-sand/all","slugLocaleMapping":{"desert-sand__all":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__microfibres-shop__microfibres",
    path: "/:locale()/shop/microfibres",
    meta: {"id":"N4Fc5rBMTfm9sPdDNGI7ag","slug":"shop__microfibres","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/microfibres","slugLocaleMapping":{"shop__microfibres":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-ski-goggle-protectors-ski-goggle-protectors",
    path: "/:locale()/ski-goggle-protectors",
    meta: {"id":"GsAHxC3vSde730dRHlb9bw","slug":"ski-goggle-protectors","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/ski-goggle-protectors","slugLocaleMapping":{"ski-goggle-protectors":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__cases-shop__cases",
    path: "/:locale()/shop/cases",
    meta: {"id":"INbYYSxCQuiZEhryleBW3g","slug":"shop__cases","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/cases","slugLocaleMapping":{"shop__cases":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-triple-black__all-triple-black__all",
    path: "/:locale()/triple-black/all",
    meta: {"id":"LqCHhjA0SiWKXqcMG3VY-A","slug":"triple-black__all","index":true,"title":"Triple Black Sunglasses │ SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/triple-black/all","slugLocaleMapping":{"triple-black__all":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-for-small-faces-sunglasses-for-small-faces",
    path: "/:locale()/sunglasses-for-small-faces",
    meta: {"id":"RiNVS9jmQmi9dt_plK5yIg","slug":"sunglasses-for-small-faces","index":true,"title":"Sunglasses for Smaller Faces | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-for-small-faces","slugLocaleMapping":{"sunglasses-for-small-faces":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-pace__performance-bestseller-pace__performance-bestseller",
    path: "/:locale()/pace/performance-bestseller",
    meta: {"id":"EtHygREfT1OdKXaq3RwjkA","slug":"pace__performance-bestseller","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/pace/performance-bestseller","slugLocaleMapping":{"pace__performance-bestseller":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-bundles__snow-bundles__snow",
    path: "/:locale()/bundles/snow",
    meta: {"id":"EAidjut8SYSbSuXaXT_m1Q","slug":"bundles__snow","index":true,"title":"Bundle & Save | Snow | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/bundles/snow","slugLocaleMapping":{"bundles__snow":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-bundles__everyday-bundles__everyday",
    path: "/:locale()/bundles/everyday",
    meta: {"id":"Un9qSndISWa4eys_antqmQ","slug":"bundles__everyday","index":true,"title":"Bundle & Save | Everyday | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/bundles/everyday","slugLocaleMapping":{"bundles__everyday":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-goggles__new-arrivals-goggles__new-arrivals",
    path: "/:locale()/goggles/new-arrivals",
    meta: {"id":"cvN_xs0ERQCQYdZq8XB5kg","slug":"goggles__new-arrivals","index":true,"title":"New Arrivals Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/goggles/new-arrivals","slugLocaleMapping":{"goggles__new-arrivals":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-black-friday-black-friday",
    path: "/:locale()/black-friday",
    meta: {"id":"dnYJkXOvTzSyJ0NL8QbVwg","slug":"black-friday","index":true,"title":"Black Friday Sunglasses & Ski Goggles 2025","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/black-friday","slugLocaleMapping":{"black-friday":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-black-friday-ski-goggles-black-friday-ski-goggles",
    path: "/:locale()/black-friday-ski-goggles",
    meta: {"id":"AMlaK_vMTPObZDfSwFx8zA","slug":"black-friday-ski-goggles","index":true,"title":"Black Friday Ski Goggles 2025","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/black-friday-ski-goggles","slugLocaleMapping":{"black-friday-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-black-friday-sunglasses-black-friday-sunglasses",
    path: "/:locale()/black-friday-sunglasses",
    meta: {"id":"RwDok_9ORJO6VteSB5NQew","slug":"black-friday-sunglasses","index":true,"title":"Black Friday Sunglasses 2025","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/black-friday-sunglasses","slugLocaleMapping":{"black-friday-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-for-round-faces-sunglasses-for-round-faces",
    path: "/:locale()/sunglasses-for-round-faces",
    meta: {"id":"AgZGSKhiRIC9JCC8Y2C1Dw","slug":"sunglasses-for-round-faces","index":true,"title":"Sunglasses for Round Faces | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-for-round-faces","slugLocaleMapping":{"sunglasses-for-round-faces":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-sunglasses-for-square-faces-sunglasses-for-square-faces",
    path: "/:locale()/sunglasses-for-square-faces",
    meta: {"id":"S_ZvBeyjRJaz_Irhm1fIow","slug":"sunglasses-for-square-faces","index":true,"title":"Sunglasses for Square Faces | SunGod. See Better.","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/sunglasses-for-square-faces","slugLocaleMapping":{"sunglasses-for-square-faces":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-goggles__bestseller-goggles-goggles__bestseller-goggles",
    path: "/:locale()/goggles/bestseller-goggles",
    meta: {"id":"IY-gmOusS4KFtLTSKh7aSw","slug":"goggles__bestseller-goggles","index":true,"extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/goggles/bestseller-goggles","slugLocaleMapping":{"goggles__bestseller-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-mens-ski-goggles-mens-ski-goggles",
    path: "/:locale()/mens-ski-goggles",
    meta: {"id":"Wq7aUrQhTjKk4I4EWZJ_iw","slug":"mens-ski-goggles","index":true,"title":"Men's Ski Goggles | Low Light & Anti-Fog","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/mens-ski-goggles","slugLocaleMapping":{"mens-ski-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-womens-goggles-womens-goggles",
    path: "/:locale()/womens-goggles",
    meta: {"id":"A3Sn9K6LS9WK8UASvvPnZQ","slug":"womens-goggles","index":true,"title":"Women's Ski & Snowboard Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/womens-goggles","slugLocaleMapping":{"womens-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "fp-shop__8ko-snow-goggles-shop__8ko-snow-goggles",
    path: "/:locale()/shop/8ko-snow-goggles",
    meta: {"id":"LOli8PoKRP2JVx61S1Xqwg","slug":"shop__8ko-snow-goggles","index":true,"title":"8KO®snow Goggles","extendedPage":true,"pageType":"Filter PLP","unlocalisedPath":"/shop/8ko-snow-goggles","slugLocaleMapping":{"shop__8ko-snow-goggles":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/filter-page/[...filter-page].vue")
  },
  {
    name: "glp-size-guide-size-guide",
    path: "/:locale()/size-guide",
    meta: {"id":"K0Q9VrgpRX-k05kvI2yWfA","slug":"size-guide","index":true,"theme":"sungod","title":"Sunglasses & Goggles Size Guide | Find Your Fit | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/size-guide","hidePageHeader":false,"slugLocaleMapping":{"size-guide":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__sungod-x-rab-win-winter-essentials-competition__sungod-x-rab-win-winter-essentials",
    path: "/:locale()/competition/sungod-x-rab-win-winter-essentials",
    meta: {"id":"K_NZMbzrT6mWncNa_F7J-A","slug":"competition__sungod-x-rab-win-winter-essentials","index":true,"theme":"sungod","title":"SunGod x Rab: Win £1,500 of Winter Essentials | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/sungod-x-rab-win-winter-essentials","hidePageHeader":false,"slugLocaleMapping":{"competition__sungod-x-rab-win-winter-essentials":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-win-with-sungod__running-win-with-sungod__running",
    path: "/:locale()/win-with-sungod/running",
    meta: {"id":"UU2W9P-bRty8eMgsHuRwQQ","slug":"win-with-sungod__running","index":true,"theme":"sungod","title":"Win a Marathon Place, Expenses Covered | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/win-with-sungod/running","hidePageHeader":false,"slugLocaleMapping":{"win-with-sungod__running":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-win-with-sungod__snow-win-with-sungod__snow",
    path: "/:locale()/win-with-sungod/snow",
    meta: {"id":"JwcSBFZ9RbagGtEsS-aLCg","slug":"win-with-sungod__snow","index":true,"theme":"sungod","title":"Win a Heliskiing Trip to Italy | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/win-with-sungod/snow","hidePageHeader":false,"slugLocaleMapping":{"win-with-sungod__snow":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-win-with-sungod__cycling-win-with-sungod__cycling",
    path: "/:locale()/win-with-sungod/cycling",
    meta: {"id":"QFoSifXqQLyPafttQq9fXw","slug":"win-with-sungod__cycling","index":true,"theme":"sungod","title":"Win a £5,000 Gravel Bike | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/win-with-sungod/cycling","hidePageHeader":false,"slugLocaleMapping":{"win-with-sungod__cycling":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-win-with-sungod-win-with-sungod",
    path: "/:locale()/win-with-sungod",
    meta: {"id":"URgQnIrTSvWUy9DxhiE-ow","slug":"win-with-sungod","index":true,"theme":"sungod","title":"Win with SunGod | Running, Cycling & Snow Competitions","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/win-with-sungod","hidePageHeader":false,"slugLocaleMapping":{"win-with-sungod":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-black-friday-sunglasses-2026-black-friday-sunglasses-2026",
    path: "/:locale()/black-friday-sunglasses-2026",
    meta: {"id":"IAt_6K8-TyWz9hddiYKg9Q","slug":"black-friday-sunglasses-2026","index":true,"theme":"sungod","title":"Black Friday Early Access | SunGod Sunglasses & Goggles","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/black-friday-sunglasses-2026","hidePageHeader":false,"slugLocaleMapping":{"black-friday-sunglasses-2026":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-snow-goggles-early-access-snow-goggles-early-access",
    path: "/:locale()/snow-goggles-early-access",
    meta: {"id":"QTqw9iSlTWeTnMNUVjKG6w","slug":"snow-goggles-early-access","index":true,"theme":"sungod","title":"SunGod AW26 Snow Goggles | Early Access Sign-Up","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/snow-goggles-early-access","hidePageHeader":false,"slugLocaleMapping":{"snow-goggles-early-access":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-autumn-lens-colours-autumn-lens-colours",
    path: "/:locale()/autumn-lens-colours",
    meta: {"id":"Nu2A1dw5S8CuRhP6PYu1Xg","slug":"autumn-lens-colours","index":true,"theme":"sungod","title":"Autumn Lens Colours: Plum | ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/autumn-lens-colours","hidePageHeader":false,"slugLocaleMapping":{"autumn-lens-colours":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-customise-your-sungods-customise-your-sungods",
    path: "/:locale()/customise-your-sungods",
    meta: {"id":"211841941","slug":"customise-your-sungods","index":true,"theme":"sungod","title":"Custom Sunglasses | Build Your Own ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/customise-your-sungods","hidePageHeader":false,"slugLocaleMapping":{"customise-your-sungods":["en-gb","en-gb","en-nz"],"customize-your-sungods":["en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-customise-your-sungods-customize-your-sungods",
    path: "/:locale()/customize-your-sungods",
    meta: {"id":"211841941","slug":"customize-your-sungods","index":true,"theme":"sungod","title":"Custom Sunglasses | Build Your Own ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/customise-your-sungods","hidePageHeader":false,"slugLocaleMapping":{"customise-your-sungods":["en-gb","en-gb","en-nz"],"customize-your-sungods":["en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__forest-bike__anything-but-underground-challenge-competition__forest-bike__anything-but-underground-challenge",
    path: "/:locale()/competition/forest-bike/anything-but-underground-challenge",
    meta: {"id":"f4zDxii8RhqqF1lgie8eqA","slug":"competition__forest-bike__anything-but-underground-challenge","index":true,"theme":"sungod","title":"Anything But Underground Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/forest-bike/anything-but-underground-challenge","hidePageHeader":false,"slugLocaleMapping":{"competition__forest-bike__anything-but-underground-challenge":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-cycling-cycling",
    path: "/:locale()/cycling",
    meta: {"id":"LVYLZhSsQxOttu66-zNLtA","slug":"cycling","index":true,"theme":"sungod","title":"Cycling Sunglasses for Road, Mountain & Gravel Bikes","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/cycling","hidePageHeader":false,"slugLocaleMapping":{"cycling":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__our-partners-purpose__our-partners",
    path: "/:locale()/purpose/our-partners",
    meta: {"id":"ANr0-s7sTce44zVjC4R3_w","slug":"purpose__our-partners","index":true,"theme":"sungod","title":"SunGod Charity Partners | ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/our-partners","hidePageHeader":false,"slugLocaleMapping":{"purpose__our-partners":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__goals-purpose__goals",
    path: "/:locale()/purpose/goals",
    meta: {"id":"T9S8YIj6THqs_V7Alp355g","slug":"purpose__goals","index":true,"theme":"sungod","title":"Our Goals At SunGod ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/goals","hidePageHeader":false,"slugLocaleMapping":{"purpose__goals":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__b-corp-purpose__b-corp",
    path: "/:locale()/purpose/b-corp",
    meta: {"id":"MwmpcJyOTN-wMbAf8_tMlQ","slug":"purpose__b-corp","index":true,"theme":"sungod","title":"B-Corp Certified ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/b-corp","hidePageHeader":false,"slugLocaleMapping":{"purpose__b-corp":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__guaranteed-for-life-purpose__guaranteed-for-life",
    path: "/:locale()/purpose/guaranteed-for-life",
    meta: {"id":"KWq6GhaeQ0-fH7D5f6QPUA","slug":"purpose__guaranteed-for-life","index":true,"theme":"sungod","title":"Guaranteed For Life ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/guaranteed-for-life","hidePageHeader":false,"slugLocaleMapping":{"purpose__guaranteed-for-life":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__design-principles-purpose__design-principles",
    path: "/:locale()/purpose/design-principles",
    meta: {"id":"bTPof42UQiSMykfeXmcdqg","slug":"purpose__design-principles","index":true,"theme":"sungod","title":"Design Principles | ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/design-principles","hidePageHeader":false,"slugLocaleMapping":{"purpose__design-principles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-mclaren-mclaren",
    path: "/:locale()/mclaren",
    meta: {"id":"GhQ_wNIPSUKW5isBuLv4gA","slug":"mclaren","index":true,"theme":"mclaren","title":"SunGod x McLaren F1 Team","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/mclaren","hidePageHeader":false,"slugLocaleMapping":{"mclaren":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-classics4pro-classics4pro",
    path: "/:locale()/classics4pro",
    meta: {"id":"PVzU0ateS-GnaUi59x1pgA","slug":"classics4pro","index":true,"theme":"sungod","title":"SunGod Classics⁴ PRO","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/classics4pro","hidePageHeader":false,"slugLocaleMapping":{"classics4pro":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-mission-mission",
    path: "/:locale()/mission",
    meta: {"id":"R-zG25J8QQ-56d38gINLLA","slug":"mission","index":true,"theme":"sungod","title":"Our Mission","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/mission","hidePageHeader":false,"slugLocaleMapping":{"mission":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-stores-stores",
    path: "/:locale()/stores",
    meta: {"id":"bRAfRRbXQV-GtmwdYbfACw","slug":"stores","index":true,"theme":"sungod","title":"SunGod Stores","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/stores","hidePageHeader":false,"slugLocaleMapping":{"stores":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-velans2-velans2",
    path: "/:locale()/velans2",
    meta: {"id":"Dckd0w6xSKmy9ZAwPQ09xQ","slug":"velans2","index":true,"theme":"sungod","title":"Velans™ 2","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/velans2","hidePageHeader":true,"slugLocaleMapping":{"velans2":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-velans2-upgrade-your-play-velans2-upgrade-your-play",
    path: "/:locale()/velans2-upgrade-your-play",
    meta: {"id":"bbnxavbuS0mc3SMJl3cMTw","slug":"velans2-upgrade-your-play","index":true,"theme":"sungod","title":"Velans 2 - Upgrade Your Play.","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/velans2-upgrade-your-play","hidePageHeader":false,"slugLocaleMapping":{"velans2-upgrade-your-play":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__strava-challenge__play-starts-now-competition__strava-challenge__play-starts-now",
    path: "/:locale()/competition/strava-challenge/play-starts-now",
    meta: {"id":"PoMMLuCrSki0ofGT7HYIkw","slug":"competition__strava-challenge__play-starts-now","index":true,"theme":"sungod","title":"Play Starts Now Strava Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/strava-challenge/play-starts-now","hidePageHeader":false,"slugLocaleMapping":{"competition__strava-challenge__play-starts-now":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__impact-report-purpose__impact-report",
    path: "/:locale()/purpose/impact-report",
    meta: {"id":"TJT9hnZHSg6ZwSkT155q2A","slug":"purpose__impact-report","index":true,"theme":"sungod","title":"Impact Report | See Better.","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/impact-report","hidePageHeader":false,"slugLocaleMapping":{"purpose__impact-report":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-purpose__our-approach-purpose__our-approach",
    path: "/:locale()/purpose/our-approach",
    meta: {"id":"S7mFpt4YQZ2Sw3FyO2ByWg","slug":"purpose__our-approach","index":true,"theme":"sungod","title":"Our Approach","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/purpose/our-approach","hidePageHeader":false,"slugLocaleMapping":{"purpose__our-approach":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-wear-tester-thank-you-wear-tester-thank-you",
    path: "/:locale()/wear-tester-thank-you",
    meta: {"id":"CGOgB-6iQNe84N_G7LLkMw","slug":"wear-tester-thank-you","index":true,"theme":"sungod","title":"Wear Tester","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/wear-tester-thank-you","hidePageHeader":false,"slugLocaleMapping":{"wear-tester-thank-you":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-pace-pace",
    path: "/:locale()/pace",
    meta: {"id":"K0bfvtcrT2WY8LVMFGQWqg","slug":"pace","index":true,"theme":"sungod","title":"Pace Sunglasses for Performance","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/pace","hidePageHeader":false,"slugLocaleMapping":{"pace":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-everyday-everyday",
    path: "/:locale()/everyday",
    meta: {"id":"INZmumRMQ7K5a_4JkdbUuQ","slug":"everyday","index":true,"theme":"sungod","title":"Sunglasses for Everyday","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/everyday","hidePageHeader":false,"slugLocaleMapping":{"everyday":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-ultras-air-ultras-air",
    path: "/:locale()/ultras-air",
    meta: {"id":"O0QtmjehQn6-Iv6nQXNciQ","slug":"ultras-air","index":true,"theme":"sungod","title":"Ultras™ Air","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/ultras-air","hidePageHeader":true,"slugLocaleMapping":{"ultras-air":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-running-running",
    path: "/:locale()/running",
    meta: {"id":"Etrg5tEzRjiBIF8ke23hKg","slug":"running","index":true,"theme":"sungod","title":"Running","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/running","hidePageHeader":false,"slugLocaleMapping":{"running":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-ss26-sunglasses-ss26-sunglasses",
    path: "/:locale()/ss26-sunglasses",
    meta: {"id":"DQ7AYiSmRUSzoRxSpSZB2Q","slug":"ss26-sunglasses","index":true,"theme":"sungod","title":"Brand-new Sunglasses for 2026","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/ss26-sunglasses","hidePageHeader":false,"slugLocaleMapping":{"ss26-sunglasses":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-renegades-renegades",
    path: "/:locale()/renegades",
    meta: {"id":"EPnoZMlQQ_SvkRshrmas1g","slug":"renegades","index":true,"theme":"sungod","title":"SunGod Renegades™ | SunGod. See Better.","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/renegades","hidePageHeader":false,"slugLocaleMapping":{"renegades":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-iris-iris",
    path: "/:locale()/iris",
    meta: {"id":"KljVBle1RHOSLNB9Xy1xww","slug":"iris","index":true,"theme":"sungod","title":"Iris™ Photochromic Lenses","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/iris","hidePageHeader":true,"slugLocaleMapping":{"iris":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-forty2s-forty2s",
    path: "/:locale()/forty2s",
    meta: {"id":"WxqyCmQWQ4GK4CGlr3EjhA","slug":"forty2s","index":true,"theme":"sungod","title":"FORTY2s™","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/forty2s","hidePageHeader":true,"slugLocaleMapping":{"forty2s":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-sungod-mclaren-1000th-gp-tokas-sungod-mclaren-1000th-gp-tokas",
    path: "/:locale()/sungod-mclaren-1000th-gp-tokas",
    meta: {"id":"Ge2lEQwXSZKhaviwuvJmSA","slug":"sungod-mclaren-1000th-gp-tokas","index":true,"theme":"mclaren","title":"SunGod x McLaren F1 Racing Team 1000th GP Tokas™","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/sungod-mclaren-1000th-gp-tokas","hidePageHeader":false,"slugLocaleMapping":{"sungod-mclaren-1000th-gp-tokas":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-protect-our-winters-protect-our-winters",
    path: "/:locale()/protect-our-winters",
    meta: {"id":"72065080","slug":"protect-our-winters","index":true,"theme":"sungod","title":"Protect Our Winters UK","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/protect-our-winters","hidePageHeader":null,"slugLocaleMapping":{"protect-our-winters":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-brand-manifesto-brand-manifesto",
    path: "/:locale()/brand-manifesto",
    meta: {"id":"JhYsmi0YS8mQgftu9TUkBg","slug":"brand-manifesto","index":true,"theme":"sungod","title":"Brand Manifesto","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/brand-manifesto","hidePageHeader":false,"slugLocaleMapping":{"brand-manifesto":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-live-in-the-light-live-in-the-light",
    path: "/:locale()/live-in-the-light",
    meta: {"id":"Zk4PA9kpTRqaIS4mXzfb-A","slug":"live-in-the-light","index":true,"theme":"","title":"Live in the Light | SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/live-in-the-light","hidePageHeader":true,"slugLocaleMapping":{"live-in-the-light":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-arcade-purple-snowboard-goggles-arcade-purple-snowboard-goggles",
    path: "/:locale()/arcade-purple-snowboard-goggles",
    meta: {"id":"MbCW4Nd4SMeHJ1uFxDRrGg","slug":"arcade-purple-snowboard-goggles","index":true,"theme":"sungod","title":"Arcade Purple | Snowboard Goggles | Game On","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/arcade-purple-snowboard-goggles","hidePageHeader":true,"slugLocaleMapping":{"arcade-purple-snowboard-goggles":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-snow-new-colours-snow-new-colours",
    path: "/:locale()/snow-new-colours",
    meta: {"id":"EJU_ENycTfeAeugz8aytqw","slug":"snow-new-colours","index":true,"theme":"sungod","title":"Fresh Snow. Fresh Colours.","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/snow-new-colours","hidePageHeader":true,"slugLocaleMapping":{"snow-new-colours":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-black-friday-sunglasses-2025-black-friday-sunglasses-2025",
    path: "/:locale()/black-friday-sunglasses-2025",
    meta: {"id":"M8G5aK7sQI-IOYSucp13TQ","slug":"black-friday-sunglasses-2025","index":true,"theme":"sungod","title":"Black Friday Sunglasses Deals 2025","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/black-friday-sunglasses-2025","hidePageHeader":false,"slugLocaleMapping":{"black-friday-sunglasses-2025":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-supply-supply",
    path: "/:locale()/supply",
    meta: {"id":"O2Rsc3IzRGSB9GHcms96YA","slug":"supply","index":true,"theme":"sungod","title":"SunGod Supply","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/supply","hidePageHeader":false,"slugLocaleMapping":{"supply":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-trail-running-trail-running",
    path: "/:locale()/trail-running",
    meta: {"id":"PqqPL43FR3W_o52p1S0Uww","slug":"trail-running","index":true,"theme":"sungod","title":"Trail Running | Sunglasses Ready for Records","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/trail-running","hidePageHeader":true,"slugLocaleMapping":{"trail-running":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-sunglasses-size-guide-sunglasses-size-guide",
    path: "/:locale()/sunglasses-size-guide",
    meta: {"id":"129609117","slug":"sunglasses-size-guide","index":true,"theme":"sungod","title":"Sunglasses Size Guide | SunGod. See Better.","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/sunglasses-size-guide","hidePageHeader":false,"slugLocaleMapping":{"sunglasses-size-guide":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-the-bike-project-the-bike-project",
    path: "/:locale()/the-bike-project",
    meta: {"id":"63538691","slug":"the-bike-project","index":true,"theme":"sungod","title":"Meet Our Partners: The Bike Project","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/the-bike-project","hidePageHeader":null,"slugLocaleMapping":{"the-bike-project":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__strava-challenge__no-better-time-competition__strava-challenge__no-better-time",
    path: "/:locale()/competition/strava-challenge/no-better-time",
    meta: {"id":"JIPSJuebRQeyLIodaaKs6w","slug":"competition__strava-challenge__no-better-time","index":true,"theme":"sungod","title":"No Better Time Strava Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/strava-challenge/no-better-time","hidePageHeader":false,"slugLocaleMapping":{"competition__strava-challenge__no-better-time":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-forty2s__solitude-forty2s__solitude",
    path: "/:locale()/forty2s/solitude",
    meta: {"id":"XD4FIxO8SWC17vfro8rntg","slug":"forty2s__solitude","index":true,"theme":"sungod","title":"FORTY2s™ Sunglasses - Solitude","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/forty2s/solitude","hidePageHeader":true,"slugLocaleMapping":{"forty2s__solitude":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-forty2s__performance-forty2s__performance",
    path: "/:locale()/forty2s/performance",
    meta: {"id":"dd1IA1PlR1qM5fK8a6ESmg","slug":"forty2s__performance","index":true,"theme":"sungod","title":"FORTY2s™ - Performance","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/forty2s/performance","hidePageHeader":true,"slugLocaleMapping":{"forty2s__performance":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-forty2s__opportunity-forty2s__opportunity",
    path: "/:locale()/forty2s/opportunity",
    meta: {"id":"Bncq6S3_T2yREWdavOuV0g","slug":"forty2s__opportunity","index":true,"theme":"sungod","title":"FORTY2s™ Sunglasses - Opportunity","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/forty2s/opportunity","hidePageHeader":true,"slugLocaleMapping":{"forty2s__opportunity":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__hackney-half-competition__hackney-half",
    path: "/:locale()/competition/hackney-half",
    meta: {"id":"elBHYyfCQnu4trS2coGSLg","slug":"competition__hackney-half","index":true,"theme":"sungod","title":"Hackney Half Reward","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/hackney-half","hidePageHeader":false,"slugLocaleMapping":{"competition__hackney-half":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-shop__infinite-recycled-frames-shop__infinite-recycled-frames",
    path: "/:locale()/shop/infinite-recycled-frames",
    meta: {"id":"63538716","slug":"shop__infinite-recycled-frames","index":true,"theme":"sungod","title":"Sunglasses with 100% Recycled Frames","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/shop/infinite-recycled-frames","hidePageHeader":null,"slugLocaleMapping":{"shop__infinite-recycled-frames":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__strava-challenge__chase-the-light-competition__strava-challenge__chase-the-light",
    path: "/:locale()/competition/strava-challenge/chase-the-light",
    meta: {"id":"Eh7KZqGDTGeUKrjp7PDqEw","slug":"competition__strava-challenge__chase-the-light","index":true,"theme":"sungod","title":"Chase The Light Strava Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/strava-challenge/chase-the-light","hidePageHeader":false,"slugLocaleMapping":{"competition__strava-challenge__chase-the-light":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-chase-your-vision-chase-your-vision",
    path: "/:locale()/chase-your-vision",
    meta: {"id":"EtEl7Hl8TH2v6Kfmf4I9Vg","slug":"chase-your-vision","index":true,"theme":"sungod","title":"Chase Your Vision with SunGod","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/chase-your-vision","hidePageHeader":false,"slugLocaleMapping":{"chase-your-vision":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-refer-a-friend-refer-a-friend",
    path: "/:locale()/refer-a-friend",
    meta: {"id":"On02-9p7QAqVO1tkwbnNxQ","slug":"refer-a-friend","index":true,"theme":"sungod","title":"Refer a Friend","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/refer-a-friend","hidePageHeader":false,"slugLocaleMapping":{"refer-a-friend":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__strava-challenge__golden-hour-competition__strava-challenge__golden-hour",
    path: "/:locale()/competition/strava-challenge/golden-hour",
    meta: {"id":"MS9F_fj2QvavA3SaiGI-fQ","slug":"competition__strava-challenge__golden-hour","index":true,"theme":"sungod","title":"Golden Hour Strava Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/strava-challenge/golden-hour","hidePageHeader":false,"slugLocaleMapping":{"competition__strava-challenge__golden-hour":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-events-purchase-events-purchase",
    path: "/:locale()/events-purchase",
    meta: {"id":"bUB_HwiLQRaKrbJZo0l1sw","slug":"events-purchase","index":true,"theme":"sungod","title":"SunGod Lifetime Guarantee Registration - Events Only ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/events-purchase","hidePageHeader":false,"slugLocaleMapping":{"events-purchase":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-tile-turnaround-tile-turnaround",
    path: "/:locale()/tile-turnaround",
    meta: {"id":"P4lN7ZadT-G1QpE4ZhAyTw","slug":"tile-turnaround","index":true,"theme":"sungod","title":"Tile Turnaround","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/tile-turnaround","hidePageHeader":false,"slugLocaleMapping":{"tile-turnaround":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-competition__strava-challenge__factor-50-competition__strava-challenge__factor-50",
    path: "/:locale()/competition/strava-challenge/factor-50",
    meta: {"id":"dZ7YyNooT_mEgo8Qm0gMng","slug":"competition__strava-challenge__factor-50","index":true,"theme":"sungod","title":"Factor 50 Strava Challenge","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/competition/strava-challenge/factor-50","hidePageHeader":false,"slugLocaleMapping":{"competition__strava-challenge__factor-50":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-create-create",
    path: "/:locale()/create",
    meta: {"id":"0Nz-_eJGSzmov0F6HHPt_g","slug":"create","index":true,"theme":"sungod","title":"SunGod Create","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/create","hidePageHeader":false,"slugLocaleMapping":{"create":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-goggles-size-guide-goggles-size-guide",
    path: "/:locale()/goggles-size-guide",
    meta: {"id":"172974147","slug":"goggles-size-guide","index":true,"theme":"sungod","title":"Ski and Snowboard Goggles Size Guide","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/goggles-size-guide","hidePageHeader":false,"slugLocaleMapping":{"goggles-size-guide":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-goggles-size-guide-goggles-size-guide/vanguards-vle_fireN-vf_blackM-vs_blackLP",
    path: "/:locale()/goggles-size-guide/vanguards-vle_fireN-vf_blackM-vs_blackLP",
    meta: {"id":"172974147","slug":"goggles-size-guide","index":false,"theme":"sungod","title":"Ski and Snowboard Goggles Size Guide","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/goggles-size-guide","hidePageHeader":false,"slugLocaleMapping":{"goggles-size-guide":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]},"sku":"vanguards-vle_fireN-vf_blackM-vs_blackLP"},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-create-terms-and-conditions-create-terms-and-conditions",
    path: "/:locale()/create-terms-and-conditions",
    meta: {"id":"ISJ4mHGBT5677kcxf2ygWg","slug":"create-terms-and-conditions","index":true,"theme":"sungod","title":"SunGod Create - Terms & Conditions Of Sale","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/create-terms-and-conditions","hidePageHeader":false,"slugLocaleMapping":{"create-terms-and-conditions":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-co-brand-co-brand",
    path: "/:locale()/co-brand",
    meta: {"id":"146687282","slug":"co-brand","index":true,"theme":"sungod","title":"Co-Brand","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/co-brand","hidePageHeader":false,"slugLocaleMapping":{"co-brand":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-see-better-see-better",
    path: "/:locale()/see-better",
    meta: {"id":"173170654","slug":"see-better","index":true,"theme":"sungod","title":"See Better with SunGod Sunglasses. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/see-better","hidePageHeader":false,"slugLocaleMapping":{"see-better":["en-gb","en-us","en-au","en-ca","en-ch","en-eu","en-nz"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-shop__limited-edition__james-woods-shop__limited-edition__james-woods",
    path: "/:locale()/shop/limited-edition/james-woods",
    meta: {"id":"95340275","slug":"shop__limited-edition__james-woods","index":true,"theme":"sungod","title":"James 'Woodsy' Woods. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/shop/limited-edition/james-woods","hidePageHeader":null,"slugLocaleMapping":{"shop__limited-edition__james-woods":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-design-your-pair-challenge-design-your-pair-challenge",
    path: "/:locale()/design-your-pair-challenge",
    meta: {"id":"173002726","slug":"design-your-pair-challenge","index":true,"theme":"sungod","title":"SunGod. Design Your Pair Strava Challenge. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/design-your-pair-challenge","hidePageHeader":false,"slugLocaleMapping":{"design-your-pair-challenge":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-TDF-TDF",
    path: "/:locale()/TDF",
    meta: {"id":"143091794","slug":"TDF","index":true,"theme":"sungod","title":"See Better with SunGod Sunglasses. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/TDF","hidePageHeader":false,"slugLocaleMapping":{"TDF":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-sungod-x-fastandcurious-competition-sungod-x-fastandcurious-competition",
    path: "/:locale()/sungod-x-fastandcurious-competition",
    meta: {"id":"141946203","slug":"sungod-x-fastandcurious-competition","index":true,"theme":"sungod","title":"McLaren F1 x SunGod Competition. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/sungod-x-fastandcurious-competition","hidePageHeader":null,"slugLocaleMapping":{"sungod-x-fastandcurious-competition":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-spencer-spencer",
    path: "/:locale()/spencer",
    meta: {"id":"138385272","slug":"spencer","index":true,"theme":"sungod","title":"SunGod x Big Fish Podcast. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/spencer","hidePageHeader":false,"slugLocaleMapping":{"spencer":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-see-better-challenge-see-better-challenge",
    path: "/:locale()/see-better-challenge",
    meta: {"id":"119019814","slug":"see-better-challenge","index":true,"theme":"sungod","title":"SunGod. See Better Strava Challenge. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/see-better-challenge","hidePageHeader":false,"slugLocaleMapping":{"see-better-challenge":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-geraint-geraint",
    path: "/:locale()/geraint",
    meta: {"id":"117978536","slug":"geraint","index":true,"theme":"sungod","title":"Geraint Thomas Cycling Club","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/geraint","hidePageHeader":false,"slugLocaleMapping":{"geraint":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-sungod-x-mclaren-competition-sungod-x-mclaren-competition",
    path: "/:locale()/sungod-x-mclaren-competition",
    meta: {"id":"123048332","slug":"sungod-x-mclaren-competition","index":true,"theme":"sungod","title":"McLaren F1 x SunGod Competition. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/sungod-x-mclaren-competition","hidePageHeader":null,"slugLocaleMapping":{"sungod-x-mclaren-competition":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-momentum-momentum",
    path: "/:locale()/momentum",
    meta: {"id":"121541279","slug":"momentum","index":true,"theme":"sungod","title":"The Momentum Campaign. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/momentum","hidePageHeader":null,"slugLocaleMapping":{"momentum":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-shop__limited-edition__england-rugby-shop__limited-edition__england-rugby",
    path: "/:locale()/shop/limited-edition/england-rugby",
    meta: {"id":"96874845","slug":"shop__limited-edition__england-rugby","index":true,"theme":"sungod","title":"SunGod x England Rugby. ","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/shop/limited-edition/england-rugby","hidePageHeader":null,"slugLocaleMapping":{"shop__limited-edition__england-rugby":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "glp-freeride-world-tour-freeride-world-tour",
    path: "/:locale()/freeride-world-tour",
    meta: {"id":"72065085","slug":"freeride-world-tour","index":true,"theme":"sungod","title":"Freeride World Tour","extendedPage":true,"pageType":"Landing Page","unlocalisedPath":"/freeride-world-tour","hidePageHeader":null,"slugLocaleMapping":{"freeride-world-tour":["en-gb","en-au","en-ca","en-ch","en-eu","en-nz","en-us"]}},
    component: () => import("/vercel/path0/pages/[locale]/generic-landing-page/[...generic-landing-page].vue")
  },
  {
    name: "pdp-renegades-le_woodsy",
    path: "/:locale()/shop/signature-series/woodsy-renegades",
    meta: {"sku":"renegades-le_woodsy","baseSku":"renegades","id":"69567299","index":true,"title":"Woodsy Signature Series Renegades™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/woodsy-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-revoltparts",
    path: "/:locale()/shop/parts/revolts",
    meta: {"sku":"revoltparts","baseSku":"revolts","id":"63537459","index":true,"title":" Revolts™ Goggles Part Kits","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/revolts"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ullrs-le_chaos27",
    path: "/:locale()/shop/limited-edition/chaos-ullrs",
    meta: {"sku":"ullrs-le_chaos27","baseSku":"ullrs","id":"CC9IvgfaQiKwEv5wgq_GPw","index":true,"title":"SunGod Chaos Ullrs™ Goggles","theme":"purple","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/chaos-ullrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ullrs",
    path: "/:locale()/shop/goggles/ullrs",
    meta: {"sku":"ullrs","baseSku":"ullrs","id":"JOxw40i8RnmJfHTVxZooWQ","index":true,"title":"SunGod Ullrs™ Goggles","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/goggles/ullrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vanguards",
    path: "/:locale()/shop/goggles/vanguards",
    meta: {"sku":"vanguards","baseSku":"vanguards","id":"63537442","index":true,"title":"SunGod Vanguards™ Goggles","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/goggles/vanguards"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-snipers",
    path: "/:locale()/shop/goggles/snipers",
    meta: {"sku":"snipers","baseSku":"snipers","id":"63537444","index":true,"title":"SunGod Snipers™ Goggles","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/goggles/snipers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4",
    path: "/:locale()/shop/sunglasses/classics4",
    meta: {"sku":"classics4","baseSku":"classics4","id":"cE6wil68TQqJX3IsZe8zwQ","index":true,"title":"SunGod Classics⁴ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/classics4"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades",
    path: "/:locale()/shop/sunglasses/renegades",
    meta: {"sku":"renegades","baseSku":"renegades","id":"63537438","index":true,"title":"SunGod Renegades™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans",
    path: "/:locale()/shop/sunglasses/vulcans",
    meta: {"sku":"vulcans","baseSku":"vulcans","id":"63537384","index":true,"title":"SunGod Vulcans™ | For Road Cycling & MTB","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gts",
    path: "/:locale()/shop/sunglasses/gts",
    meta: {"sku":"gts","baseSku":"gts","id":"116703971","index":true,"title":"SunGod GTs™ | For Cycling","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/gts"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velanslrk",
    path: "/:locale()/shop/lenses/velans",
    meta: {"sku":"velanslrk","baseSku":"velans","id":"63537430","index":true,"title":" SunGod Velans™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4lrk",
    path: "/:locale()/shop/lenses/classics4",
    meta: {"sku":"classics4lrk","baseSku":"classics4","id":"BEJNnldjRPqv1Ix1fs9uGA","index":true,"title":"SunGod Classics⁴ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/classics4"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultrasair",
    path: "/:locale()/shop/sunglasses/ultrasair",
    meta: {"sku":"ultrasair","baseSku":"ultrasair","id":"B62Y0v3oTBKqBWZHON9WfQ","index":true,"title":"SunGod Ultras™ Air | For Total Focus","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/ultrasair"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras",
    path: "/:locale()/shop/sunglasses/ultras",
    meta: {"sku":"ultras","baseSku":"ultras","id":"116109032","index":true,"title":"SunGod Ultras™ | For Running","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/ultras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_yankees",
    path: "/:locale()/shop/limited-edition/renegades-le_yankees",
    meta: {"sku":"renegades-le_yankees","baseSku":"renegades","id":"Uxi0ojXDQsOIKaMRc6mRpw","index":true,"title":"New York Yankees Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_yankees"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibres-le_sol25",
    path: "/:locale()/shop/accessories/shades-of-love-microfibre",
    meta: {"sku":"microfibres-le_sol25","baseSku":"microfiber","id":"cpnBXG8ERBmUQQpET1L3ZA","index":true,"title":"Shades of Love Charity Microfibre","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/shades-of-love-microfibre"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-forty2s-le_neon",
    path: "/:locale()/shop/limited-edition/neon-blue-forty2s",
    meta: {"sku":"forty2s-le_neon","baseSku":"forty2s","id":"HzTx7gLIRFyjU3eKwE7B0Q","index":true,"title":"SunGod Limited Edition Neon FORTY2s™","theme":"neon","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/neon-blue-forty2s"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-forty2s-le_mclaren26-papaya",
    path: "/:locale()/shop/limited-edition/mclaren26-forty2s",
    meta: {"sku":"forty2s-le_mclaren26-papaya","baseSku":"forty2s","id":"WTR_WkYjRZSvPcIyuesAaw","index":true,"title":"McLaren F1 Team Papaya FORTY2s™ 2026","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-forty2s"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-forty2s",
    path: "/:locale()/shop/sunglasses/forty2s",
    meta: {"sku":"forty2s","baseSku":"forty2s","id":"Lkxs8VIZS9OKX2VDp9i_Bw","index":true,"title":"SunGod FORTY2s™ | For Runners","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/forty2s"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_courtneycore25",
    path: "/:locale()/shop/limited-edition/courtney-core-classics-25",
    meta: {"sku":"classics4-le_courtneycore25","baseSku":"classics4","id":"NN0OA-JRSNCHAhxW3jWsKA","index":true,"title":"SunGod Courtney Dauwalter Core Classics⁴","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/courtney-core-classics-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_courtney",
    path: "/:locale()/shop/limited-edition/courtney-classics",
    meta: {"sku":"classics4-le_courtney","baseSku":"classics4","id":"cdJrCoPOTviClT9fyARxew","index":true,"title":"SunGod Courtney Dauwalter Classics³","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/courtney-classics"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierraslrk",
    path: "/:locale()/shop/lenses/sierras",
    meta: {"sku":"sierraslrk","baseSku":"sierras","id":"63537441","index":true,"title":" SunGod Sierras™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempestslrk",
    path: "/:locale()/shop/lenses/tempests",
    meta: {"sku":"tempestslrk","baseSku":"tempests","id":"121934243","index":true,"title":"SunGod Tempests™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/tempests"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokaslrk",
    path: "/:locale()/shop/lenses/tokas",
    meta: {"sku":"tokaslrk","baseSku":"tokas","id":"118429377","index":true,"title":" SunGod Tokas™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miraslrk",
    path: "/:locale()/shop/lenses/miras",
    meta: {"sku":"miraslrk","baseSku":"miras","id":"JjawnbaPSeONY8qWg5Vp0Q","index":true,"title":" SunGod Miras™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrslrk",
    path: "/:locale()/shop/lenses/zephyrs",
    meta: {"sku":"zephyrslrk","baseSku":"zephyrs","id":"122331765","index":true,"title":" SunGod Zephyrs™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4prolrk",
    path: "/:locale()/shop/lenses/classics4pro",
    meta: {"sku":"classics4prolrk","baseSku":"classics4pro","id":"ZApUg2EURZ-UUGesyg1rUw","index":true,"title":"SunGod Classics⁴ PRO Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/classics4pro"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegadeslrk",
    path: "/:locale()/shop/lenses/renegades",
    meta: {"sku":"renegadeslrk","baseSku":"renegades","id":"63537439","index":true,"title":"SunGod Renegades™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_mclaren26-monaco",
    path: "/:locale()/shop/limited-edition/mclaren26-tokas-monaco",
    meta: {"sku":"tokas-le_mclaren26-monaco","baseSku":"tokas","id":"GccLysUuQeCFhcZ18GT3eQ","index":true,"title":"SunGod x McLaren Tokas™ Papaya Vision Sunglasses","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-tokas-monaco"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_eilish26",
    path: "/:locale()/shop/limited-edition/eilish-mccolgan-ultrasair",
    meta: {"sku":"ultras-le_eilish26","baseSku":"ultrasair","id":"REDGJ3zPR_yxjJRogZVxsg","index":true,"title":"Eilish McColgan Signature Ultras™ Air |","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/eilish-mccolgan-ultrasair"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans-le_desertsand",
    path: "/:locale()/shop/limited-edition/desert-sand/velans",
    meta: {"sku":"velans-le_desertsand","baseSku":"velans","id":"fs8iHWlpQG2A7OY6IHKnYA","index":true,"title":"Desert Sand Velans™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/desert-sand/velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempests",
    path: "/:locale()/shop/sunglasses/tempests",
    meta: {"sku":"tempests","baseSku":"tempests","id":"121923781","index":true,"title":"SunGod Tempests™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/tempests"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras",
    path: "/:locale()/shop/sunglasses/miras",
    meta: {"sku":"miras","baseSku":"miras","id":"UKAC3XfDR3mMbC09po4Srg","index":true,"title":"SunGod Miras™ Sunglasses ","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans2",
    path: "/:locale()/shop/sunglasses/velans2",
    meta: {"sku":"velans2","baseSku":"velans2","id":"UETHPEEPQtWxr9UKrxK0nw","index":true,"title":"SunGod Velans™ 2 | Upgrade Your Play","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/velans2"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_8londonbrick",
    path: "/:locale()/shop/limited-edition/brick/tokas",
    meta: {"sku":"tokas-le_8londonbrick","baseSku":"tokas","id":"GJXmFsghQ_ObVlCqb9u91g","index":true,"title":"Brick Tokas™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/brick/tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4pro-le_courtney26",
    path: "/:locale()/shop/limited-edition/courtney-classicspro",
    meta: {"sku":"classics4pro-le_courtney26","baseSku":"classics4pro","id":"N979QcWpQbWntync-zVTPw","index":true,"title":"SunGod Courtney Dauwalter Classics⁴ PRO","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/courtney-classicspro"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_rockets26",
    path: "/:locale()/shop/limited-edition/rockets-miras",
    meta: {"sku":"miras-le_rockets26","baseSku":"miras","id":"RgOUnVgyTneycLtcnqCJkw","index":true,"title":"Rockets Cycling Team Limited Edition Miras™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/rockets-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans2-le_rockets26",
    path: "/:locale()/shop/limited-edition/rockets-velans2",
    meta: {"sku":"velans2-le_rockets26","baseSku":"velans2","id":"MtyeLbsOQoCKJjX2WtYy0g","index":true,"title":"Rockets Cycling Team Limited Edition Velans™ 2","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/rockets-velans2"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcansvent",
    path: "/:locale()/shop/sunglasses/vulcansvent",
    meta: {"sku":"vulcansvent","baseSku":"vulcansvent","id":"b79ZQKqqS1qv1FVUReFvwg","index":true,"title":"SunGod Vulcans™ Vent | For Road Cycling & MTB","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/vulcansvent"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclaren26-papaya",
    path: "/:locale()/shop/limited-edition/mclaren26-sierras-papaya",
    meta: {"sku":"sierras-le_mclaren26-papaya","baseSku":"sierras","id":"RCKGB5jqQo2vMh5Q2lZg4g","index":true,"title":"McLaren F1 Team SunGod Sierras™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-sierras-papaya"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclaren26",
    path: "/:locale()/shop/limited-edition/mclaren26-sierras",
    meta: {"sku":"sierras-le_mclaren26","baseSku":"sierras","id":"JOnv7fexRbWWGpbVk1tGlg","index":true,"title":"McLaren F1 Team SunGod Sierras™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras",
    path: "/:locale()/shop/sunglasses/sierras",
    meta: {"sku":"sierras","baseSku":"sierras","id":"63537440","index":true,"title":"SunGod Sierras™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airas",
    path: "/:locale()/shop/sunglasses/airas",
    meta: {"sku":"airas","baseSku":"airas","id":"63537476","index":true,"title":"SunGod Airas™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/airas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_ecb25",
    path: "/:locale()/shop/limited-edition/ecb-miras-2025",
    meta: {"sku":"miras-le_ecb25","baseSku":"miras","id":"C-prloqBRX6ov4anRETCMg","index":true,"title":"Limited Edition England Cricket Miras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ecb-miras-2025"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_mclaren26-tortoise",
    path: "/:locale()/shop/limited-edition/mclaren26-miras-tortoise",
    meta: {"sku":"miras-le_mclaren26-tortoise","baseSku":"miras","id":"bn5HVUpcQdGRaoqhkaBOUg","index":true,"title":"Limited Edition McLaren Miras™ Tortoise","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-miras-tortoise"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_mclaren26",
    path: "/:locale()/shop/limited-edition/mclaren26-miras",
    meta: {"sku":"miras-le_mclaren26","baseSku":"miras","id":"MfRYSatmTsCxt8YQY_b-dw","index":true,"title":"Limited Edition McLaren Miras™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_redsox",
    path: "/:locale()/shop/limited-edition/zephyrs-le_redsox",
    meta: {"sku":"zephyrs-le_redsox","baseSku":"zephyrs","id":"TIaLtUzwRxS6ztl2FeehpQ","index":true,"title":"Boston Red Sox Zephyrs™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_redsox"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_yankees",
    path: "/:locale()/shop/limited-edition/zephyrs-le_yankees",
    meta: {"sku":"zephyrs-le_yankees","baseSku":"zephyrs","id":"V79DhfT2SX6ZBiMhTbVUkQ","index":true,"title":"New York Yankees Zephyrs™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_yankees"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_dodgers",
    path: "/:locale()/shop/limited-edition/zephyrs-le_dodgers",
    meta: {"sku":"zephyrs-le_dodgers","baseSku":"zephyrs","id":"D4ELoef2Qyit7QyCnapwtQ","index":true,"title":"LA Dodgers Zephyrs™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_dodgers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_padres",
    path: "/:locale()/shop/limited-edition/zephyrs-le_padres",
    meta: {"sku":"zephyrs-le_padres","baseSku":"zephyrs","id":"V_82_s8VSLSE9cfJd9cCVQ","index":true,"title":"San Diego Padres Zephyrs™: Official Eyewear Supplier","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ineos26",
    path: "/:locale()/shop/limited-edition/netcompany-ineos-zephyrs",
    meta: {"sku":"zephyrs-le_ineos26","baseSku":"zephyrs","id":"CbkGiWreRMm9fl1UKuCdqQ","index":true,"title":"Netcompany INEOS Cycling Team Zephyrs™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/netcompany-ineos-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln1-neon26",
    path: "/:locale()/shop/limited-edition/lando-norris-zephyrs-neon-26",
    meta: {"sku":"zephyrs-le_ln1-neon26","baseSku":"zephyrs","id":"G9PLBR3NQi2PkWb5bCcZCg","index":true,"title":"Limited Edition Lando Norris Sunglasses - Zephyrs™ Neon 26","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-zephyrs-neon-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln1-26",
    path: "/:locale()/shop/limited-edition/lando-norris-zephyrs-26",
    meta: {"sku":"zephyrs-le_ln1-26","baseSku":"zephyrs","id":"Mmnw6en4REyBX3wGiEQNyg","index":true,"title":"Limited Edition Lando Norris Sunglasses - Zephyrs™ 26","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-zephyrs-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs",
    path: "/:locale()/shop/sunglasses/zephyrs",
    meta: {"sku":"zephyrs","baseSku":"zephyrs","id":"122126609","index":true,"title":"SunGod Zephyrs™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-forty2s-le_chelseasodaro",
    path: "/:locale()/shop/limited-edition/chelsea-sodaro-forty2s",
    meta: {"sku":"forty2s-le_chelseasodaro","baseSku":"forty2s","id":"eteCZ6a9TyC46j0f29PkXg","index":true,"title":"Chelsea Sodaro FORTY2s™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/chelsea-sodaro-forty2s"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_mclaren26-tortoise",
    path: "/:locale()/shop/limited-edition/mclaren26-tokas-tortoise",
    meta: {"sku":"tokas-le_mclaren26-tortoise","baseSku":"tokas","id":"TjRl_ITMTW6nPOuU2ajzMg","index":true,"title":"SunGod x McLaren Tokas™ Sunglasses","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-tokas-tortoise"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_mclaren26-1000thgp",
    path: "/:locale()/shop/limited-edition/mclaren26-tokas-1000thgp",
    meta: {"sku":"tokas-le_mclaren26-1000thgp","baseSku":"tokas","id":"Z26kLaAoScKmDUBpZgX4dA","index":true,"title":"SunGod x McLaren Tokas™ 1000th GP Sunglasses","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-tokas-1000thgp"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas",
    path: "/:locale()/shop/sunglasses/tokas",
    meta: {"sku":"tokas","baseSku":"tokas","id":"118023005","index":true,"title":"SunGod Tokas™ Sunglasses ","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans2-le_sdworx26",
    path: "/:locale()/shop/limited-edition/sd-worx-velans2",
    meta: {"sku":"velans2-le_sdworx26","baseSku":"velans2","id":"Ys5AhSoTSuuLn9NMnnqMRA","index":true,"title":"Team SD Worx-Protime Limited Edition Velans™ 2","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sd-worx-velans2"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans2-le_ineos26",
    path: "/:locale()/shop/limited-edition/netcompany-ineos-velans2",
    meta: {"sku":"velans2-le_ineos26","baseSku":"velans2","id":"T1-yxMXHQuuAlUP02wucrg","index":true,"title":"Netcompany INEOS Limited Edition Velans™ 2","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/netcompany-ineos-velans2"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_padres",
    path: "/:locale()/shop/limited-edition/classics4-le_padres",
    meta: {"sku":"classics4-le_padres","baseSku":"classics4","id":"P2palFF1RuSsB43n8UKDFA","index":true,"title":"San Diego Padres Classics⁴: Official Eyewear Supplier","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/classics4-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4pro",
    path: "/:locale()/shop/sunglasses/classics4pro",
    meta: {"sku":"classics4pro","baseSku":"classics4pro","id":"ExgZY5aGQVC8WQVufIPNbQ","index":true,"title":"Classics⁴ PRO Sunglasses | Lightweight & Stable","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/classics4pro"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_op81-melbourne26",
    path: "/:locale()/shop/limited-edition/oscar-piastri-renegades-melbourne26",
    meta: {"sku":"renegades-le_op81-melbourne26","baseSku":"renegades","id":"CnaKiVMWQEK0UqB2doOlcA","index":true,"title":"Oscar Piastri x SunGod OP81 Renegades™ Australia 26","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/oscar-piastri-renegades-melbourne26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren26-papaya",
    path: "/:locale()/shop/limited-edition/mclaren26-renegades-papaya",
    meta: {"sku":"renegades-le_mclaren26-papaya","baseSku":"renegades","id":"VdTpkGiXTzWJw-lZ5nF_yg","index":true,"title":"McLaren F1 Team SunGod Renegades™ Papaya","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-renegades-papaya"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_op81-26",
    path: "/:locale()/shop/limited-edition/oscar-piastri-renegades-26",
    meta: {"sku":"renegades-le_op81-26","baseSku":"renegades","id":"OZH_ENjyRi21N-hoKAUvlg","index":true,"title":"Oscar Piastri x SunGod OP81 Renegades™ 26","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/oscar-piastri-renegades-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren26-plus",
    path: "/:locale()/shop/limited-edition/mclaren26-renegades-plus",
    meta: {"sku":"renegades-le_mclaren26-plus","baseSku":"renegades","id":"dNNO5Y3nQfmhQm4ab4DAmQ","index":true,"title":"McLaren F1 Team SunGod Renegades™ Plus","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-renegades-plus"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren26",
    path: "/:locale()/shop/limited-edition/mclaren26-renegades",
    meta: {"sku":"renegades-le_mclaren26","baseSku":"renegades","id":"Qe5rm4wtSVywlIjge--W_Q","index":true,"title":"McLaren F1 Team SunGod Renegades™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_ecb25",
    path: "/:locale()/shop/limited-edition/ecb-renegades-2025",
    meta: {"sku":"renegades-le_ecb25","baseSku":"renegades","id":"C8zXZE60SE6vZmuVSfVNDA","index":true,"title":"Limited Edition England Cricket Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ecb-renegades-2025"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_ecb",
    path: "/:locale()/shop/limited-edition/ecb-renegades",
    meta: {"sku":"renegades-le_ecb","baseSku":"renegades","id":"G-abbyMvRY24tpHIc6w4TA","index":true,"title":"Limited Edition England Cricket Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ecb-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_redsox",
    path: "/:locale()/shop/limited-edition/renegades-le_redsox",
    meta: {"sku":"renegades-le_redsox","baseSku":"renegades","id":"K58L-f9yQ1m-RoWAoxLQEg","index":true,"title":"Boston Red Sox Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_redsox"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_giants",
    path: "/:locale()/shop/limited-edition/renegades-le_giants",
    meta: {"sku":"renegades-le_giants","baseSku":"renegades","id":"TAvAPF-lSAesQCd3cFcF-A","index":true,"title":"San Francisco Giants Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_giants"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_dodgers",
    path: "/:locale()/shop/limited-edition/renegades-le_dodgers",
    meta: {"sku":"renegades-le_dodgers","baseSku":"renegades","id":"c7ybxpIaTGGdsqTS-Arsjg","index":true,"title":"LA Dodgers Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_dodgers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_astros",
    path: "/:locale()/shop/limited-edition/renegades-le_astros",
    meta: {"sku":"renegades-le_astros","baseSku":"renegades","id":"edoLzwnzR7aImInmTqNKcQ","index":true,"title":"Houston Astros Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_astros"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_padres",
    path: "/:locale()/shop/limited-edition/renegades-le_padres",
    meta: {"sku":"renegades-le_padres","baseSku":"renegades","id":"XLMkjPFjRzuYqcsRKZEdJA","index":true,"title":"San Diego Padres Renegades™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/renegades-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-pe_nosepads3",
    path: "/:locale()/shop/parts/nosepads",
    meta: {"sku":"pe_nosepads3","baseSku":"pe_nosepads3","id":"Xy56-xs5S5e2OboZgBNOpQ","index":true,"title":"Nose Pad Replacement Kit","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/nosepads"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_hayden25",
    path: "/:locale()/shop/signature-series/hayden-wilde-ultras-2025-sunglasses",
    meta: {"sku":"ultras-le_hayden25","baseSku":"Ultras","id":"JY56VR3PQEO8Omqx8D9Hwg","index":true,"title":"Hayden Wilde Signature Series Ultras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/hayden-wilde-ultras-2025-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_tomevans25",
    path: "/:locale()/shop/signature-series/tom-evans-2025-ultras-sunglasses",
    meta: {"sku":"ultras-le_tomevans25","baseSku":"Ultras","id":"eWuxKp1MQ36I3aJVmZVQbg","index":true,"title":"SunGod Tom Evans Signature Series","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/tom-evans-2025-ultras-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_hayden",
    path: "/:locale()/shop/signature-series/hayden-wilde-ultras-sunglasses",
    meta: {"sku":"ultras-le_hayden","baseSku":"Ultras","id":"N9k595xBSkGrX0Ccgm75JA","index":true,"title":"Hayden Wilde Signature Series Ultras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/hayden-wilde-ultras-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_tomevans",
    path: "/:locale()/shop/signature-series/tom-evans-ultras-sunglasses",
    meta: {"sku":"ultras-le_tomevans","baseSku":"Ultras","id":"134166787","index":true,"title":"SunGod Tom Evans Signature Series","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/tom-evans-ultras-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans",
    path: "/:locale()/shop/sunglasses/velans",
    meta: {"sku":"velans","baseSku":"velans","id":"63537411","index":true,"title":"SunGod Velans™ | For Cyclists","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_mclaren24",
    path: "/:locale()/shop/limited-edition/mclaren-vulcans",
    meta: {"sku":"vulcans-le_mclaren24","baseSku":"vulcans","id":"GMLCFn_qQhiJOTwepMDu8A","index":true,"title":"McLaren Limited Edition Vulcans™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_mclaren25",
    path: "/:locale()/shop/limited-edition/mclaren-vulcans-25",
    meta: {"sku":"vulcans-le_mclaren25","baseSku":"vulcans","id":"eLF8TMaqT56Xh_A7elDnFQ","index":true,"title":"McLaren Limited Edition Vulcans™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-vulcans-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-cap",
    path: "/:locale()/shop/accessories/running-cap",
    meta: {"sku":"cap","baseSku":"cap","id":"HaabzKOxQhqKDZxtMXApYA","index":true,"title":"SunGod Running Cap","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/running-cap"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers26-hf",
    path: "/:locale()/shop/limited-edition/ineos-vulcans-26-hf",
    meta: {"sku":"vulcans-le_ineosgrenadiers26-hf","baseSku":"vulcans","id":"Nxu-uHAETeqMAhtMC1a8lg","index":true,"title":"Netcompany INEOS Team Edition Vulcans™ HF","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-vulcans-26-hf"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers26-ff",
    path: "/:locale()/shop/limited-edition/ineos-vulcans-26-ff",
    meta: {"sku":"vulcans-le_ineosgrenadiers26-ff","baseSku":"vulcans","id":"DxKc90vyTP-ed4Pvl46c1g","index":true,"title":"Netcompany INEOS Cycling Team Edition Vulcans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-vulcans-26-ff"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers26-vent",
    path: "/:locale()/shop/limited-edition/ineos-vulcans-vent-26",
    meta: {"sku":"vulcans-le_ineosgrenadiers26-vent","baseSku":"vulcansvent","id":"RvuqDGS0RTCkuuAY2j8KUw","index":true,"title":"Netcompany INEOS Team Edition Vulcans™ Vent","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-vulcans-vent-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_mclaren26-silverstone",
    path: "/:locale()/shop/limited-edition/mclaren26-silverstone-zephyrs",
    meta: {"sku":"zephyrs-le_mclaren26-silverstone","baseSku":"zephyrs","id":"JDoU9uZFQquemElShZek3Q","index":true,"title":"SunGod x McLaren Silverstone Zephyrs™ Sunglasses","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren26-silverstone-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcansventlrk",
    path: "/:locale()/shop/lenses/vulcansvent",
    meta: {"sku":"vulcansventlrk","baseSku":"vulcansvent","id":"GndOAT1PT0GjU5xt7MBjww","index":true,"title":" SunGod Vulcans™ Vent Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/vulcansvent"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sungodrunningsocks",
    path: "/:locale()/shop/accessories/running-socks",
    meta: {"sku":"sungodrunningsocks","baseSku":"sungodrunningsocks","id":"DGuQiW2URUecOcr1G6nxvw","index":true,"title":"SunGod Crew Running Sock","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/running-socks"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-earsocksrk",
    path: "/:locale()/shop/parts/earsocks",
    meta: {"sku":"earsocksrk","baseSku":"earsocksrk","id":"QdsHBZgHTgqKQX9thbDVqA","index":true,"title":" SunGod Replacement Grips","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/earsocks"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_newera",
    path: "/:locale()/shop/limited-edition/new-era-vulcans-sunglasses",
    meta: {"sku":"vulcans-le_newera","baseSku":"vulcans","id":"GTT7jgxnSFWYtLmJOC7PFw","index":true,"title":"Limited Edition SunGod x New Era Vulcans™ Sunglasses","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-vulcans-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln4",
    path: "/:locale()/shop/limited-edition/lando-norris-zephyrs",
    meta: {"sku":"zephyrs-le_ln4","baseSku":"zephyrs","id":"122221369","index":true,"title":"Limited Edition Lando Norris Sunglasses - Zephyrs™","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-lifestylecarebundle",
    path: "/:locale()/shop/accessories/lifestyle-care-bundle",
    meta: {"sku":"lifestylecarebundle","baseSku":"","id":"YeaGYcG_QbmBZ7jU6h7nyw","index":true,"title":"Everyday Series Care Bundle","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/lifestyle-care-bundle"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_mclaren25",
    path: "/:locale()/shop/limited-edition/mclaren25-miras",
    meta: {"sku":"miras-le_mclaren25","baseSku":"miras","id":"SgBV0Yn6QaO-6hihDzBTqg","index":true,"title":"Limited Edition McLaren Miras™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren25-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans2lrk",
    path: "/:locale()/shop/lenses/velans2",
    meta: {"sku":"velans2lrk","baseSku":"velans2","id":"SGiCLL_yT3i1OnsZtiBWgQ","index":true,"title":" SunGod Velans™ 2 Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/velans2"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_giants",
    path: "/:locale()/shop/limited-edition/zephyrs-le_giants",
    meta: {"sku":"zephyrs-le_giants","baseSku":"zephyrs","id":"IES5C9myThWPw7IekfQKsg","index":true,"title":"San Francisco Giants Zephyrs™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_giants"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_astros",
    path: "/:locale()/shop/limited-edition/zephyrs-le_astros",
    meta: {"sku":"zephyrs-le_astros","baseSku":"zephyrs","id":"KkeunvNqSgaC73xIzCyfdg","index":true,"title":"Houston Astros Zephyrs™ Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/zephyrs-le_astros"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airas-le_ineosgrenadiers",
    path: "/:locale()/shop/limited-edition/ineos-grenadiers-airas",
    meta: {"sku":"airas-le_ineosgrenadiers","baseSku":"airas","id":"106412047","index":true,"title":"INEOS Grenadiers Team Edition Airas™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-grenadiers-airas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultrasairlrk",
    path: "/:locale()/shop/lenses/ultrasair",
    meta: {"sku":"ultrasairlrk","baseSku":"ultrasairlrk","id":"GND-gOaqQSegCrq5373uhw","index":true,"title":"SunGod Ultras™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/ultrasair"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers25-tdf",
    path: "/:locale()/shop/limited-edition/ineos-grenadiers-vulcans-tdf-2025",
    meta: {"sku":"vulcans-le_ineosgrenadiers25-tdf","baseSku":"vulcans","id":"YMtI2KfUTY2qxRez4LMrew","index":true,"title":"INEOS Grenadiers 2025 Summer Edition Vulcans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-grenadiers-vulcans-tdf-2025"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers25",
    path: "/:locale()/shop/limited-edition/ineos-grenadiers-vulcans-2025",
    meta: {"sku":"vulcans-le_ineosgrenadiers25","baseSku":"vulcans","id":"f8xTJL09R0Wg-q_Vy1lhOg","index":true,"title":"INEOS Grenadiers Team Edition Vulcans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-grenadiers-vulcans-2025"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-case-ct_capsule",
    path: "/:locale()/shop/cases/sunglasses-capsule-case",
    meta: {"sku":"case-ct_capsule","baseSku":"case-ct_capsule","id":"ND9lVWj_RECMdM7hXHQi8A","index":true,"title":"Everyday Series™ Capsule Case","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/cases/sunglasses-capsule-case"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_courtney25",
    path: "/:locale()/shop/limited-edition/courtney-classics-25",
    meta: {"sku":"classics4-le_courtney25","baseSku":"classics4","id":"WXdTAN5KSTywQDUcrdrn3g","index":true,"title":"SunGod Courtney Dauwalter Classics³","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/courtney-classics-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_ecb",
    path: "/:locale()/shop/limited-edition/ecb-miras",
    meta: {"sku":"miras-le_ecb","baseSku":"miras","id":"eZtsfhqKRoiFSrB3r4ILxg","index":true,"title":"Limited Edition England Cricket Miras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ecb-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-case-ct_pacecapsule",
    path: "/:locale()/shop/cases/pace-series-capsule-case",
    meta: {"sku":"case-ct_pacecapsule","baseSku":"case-ct_pacecapsule","id":"SnDDAQyxQj2rmTr4Mh2Pew","index":true,"title":"Pace Series™ Capsule Case","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/cases/pace-series-capsule-case"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-case-ct_compactvanguards",
    path: "/:locale()/shop/cases/goggles-compact-case",
    meta: {"sku":"case-ct_compactvanguards","baseSku":"case-ct_compactvanguards","id":"dM3nGAU0TUKynS8nVw5BRQ","index":true,"title":"Snow Series™ Compact Case","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/cases/goggles-compact-case"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-pacecarebundle",
    path: "/:locale()/shop/accessories/pace-care-bundle",
    meta: {"sku":"pacecarebundle","baseSku":"","id":"O162r42uSeOF3FgvfjzgbA","index":true,"title":"Pace Series Care Bundle","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/pace-care-bundle"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibre-le_pow23",
    path: "/:locale()/shop/microfiber-le_pow23",
    meta: {"sku":"microfibre-le_pow23","baseSku":"microfiber","id":"144168445","index":true,"theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/microfiber-le_pow23"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-lenscleankit",
    path: "/:locale()/shop/accessories/lens-cleaning-kit",
    meta: {"sku":"lenscleankit","baseSku":"","id":"Z9GY8-hPRLqgVlj5MBYJrA","index":true,"title":"Lens Cleaning Kit","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/lens-cleaning-kit"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gogglelensprotector-gc_blue",
    path: "/:locale()/shop/accessories/goggle-lens-protector/blue",
    meta: {"sku":"gogglelensprotector-gc_blue","baseSku":"gogglelensprotector","id":"CjCOw7gARDGfjdv_DxoJJA","index":true,"title":"Blue Goggle Lens Protector","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/goggle-lens-protector/blue"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gogglelensprotector-gc_black",
    path: "/:locale()/shop/accessories/goggle-lens-protector/black",
    meta: {"sku":"gogglelensprotector-gc_black","baseSku":"gogglelensprotector","id":"FVR1fJ-nR0uzjxU74UakqQ","index":true,"title":"Black Goggle Lens Protector","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/goggle-lens-protector/black"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-case-ct_revoltcapsule",
    path: "/:locale()/shop/cases/goggles-capsule-case",
    meta: {"sku":"case-ct_revoltcapsule","baseSku":"case-ct_revoltcapsule","id":"RGc_A2MTTCSn7NFif5DBCg","index":true,"title":"Snow Series™ Capsule Case","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/cases/goggles-capsule-case"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-case-ct_compactsnipers",
    path: "/:locale()/shop/cases/snipers-compact-case",
    meta: {"sku":"case-ct_compactsnipers","baseSku":"case-ct_compactsnipers","id":"CSPkPWs8TAemUnJ2Apyp7w","index":true,"title":"Snipers™ Compact Case","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/cases/snipers-compact-case"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ge_microfiber-pow25",
    path: "/:locale()/shop/protect-our-winters-microfibre-2025",
    meta: {"sku":"ge_microfiber-pow25","baseSku":"microfiber","id":"EvbyQsIST2CRIzT8Z_cS7Q","index":true,"title":"Protect Our Winters Charity Microfibre Pouch ","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/protect-our-winters-microfibre-2025"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibres-le_tbp25",
    path: "/:locale()/shop/microfibres-le_tbp25",
    meta: {"sku":"microfibres-le_tbp25","baseSku":"microfiber","id":"fK-D1Is1T6GFuDXBhY1mSg","index":true,"title":"The Bike Project Charity Microfibre Pouch","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/microfibres-le_tbp25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibre-le_snowx2",
    path: "/:locale()/shop/accessories/snow-microfibre-kit",
    meta: {"sku":"microfibre-le_snowx2","baseSku":"microfibre","id":"VaipNX3ITSaTgauNuolb1A","index":true,"title":"Snow Microfibre Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/snow-microfibre-kit"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibre-le_lifestylex2",
    path: "/:locale()/shop/accessories/lifestyle-microfibre-kit",
    meta: {"sku":"microfibre-le_lifestylex2","baseSku":"microfibre","id":"106399845","index":true,"title":"Lifestyle Microfibre Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/lifestyle-microfibre-kit"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-microfibre-le_pacex2",
    path: "/:locale()/shop/accessories/pace-microfibre-kit",
    meta: {"sku":"microfibre-le_pacex2","baseSku":"microfibre","id":"212098380","index":true,"title":"Pace Microfibre Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/pace-microfibre-kit"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gtslrk",
    path: "/:locale()/shop/lenses/gts",
    meta: {"sku":"gtslrk","baseSku":"gts","id":"V4Z-I3jDTsKnhTX-4gvGYg","index":true,"title":" SunGod GTs™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/gts"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_mclaren25",
    path: "/:locale()/shop/limited-edition/mclaren25-zephyrs",
    meta: {"sku":"zephyrs-le_mclaren25","baseSku":"zephyrs","id":"HHHqnK38QWeSQxX_m6jASg","index":true,"title":"Limited Edition McLaren Zephyrs Sunglasses.","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren25-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln4-neon",
    path: "/:locale()/shop/limited-edition/lando-norris-neon-zephyrs",
    meta: {"sku":"zephyrs-le_ln4-neon","baseSku":"zephyrs","id":"TLfURBmJRiOLgXVqOJibWQ","index":true,"title":"Limited Edition Lando Norris Neon Zephyrs™ Sunglasses","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-neon-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_mclaren25-miami",
    path: "/:locale()/shop/limited-edition/mclaren25-miami-miras",
    meta: {"sku":"miras-le_mclaren25-miami","baseSku":"miras","id":"EEnxNIQPTZyKcsYN8rBvRA","index":true,"title":"Limited Edition McLaren F1 Team Miami Miras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren25-miami-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_8londonbrick",
    path: "/:locale()/shop/limited-edition/brick/vulcans",
    meta: {"sku":"vulcans-le_8londonbrick","baseSku":"vulcans","id":"bHNxrWqdSGOfzN6o315GRg","index":true,"title":"Brick Vulcans™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/brick/vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_8londonbrick",
    path: "/:locale()/shop/limited-edition/brick/zephyrs",
    meta: {"sku":"zephyrs-le_8londonbrick","baseSku":"zephyrs","id":"Kod07wv7QqCccPWu3Exxfg","index":true,"title":"Brick Zepyrs™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/brick/zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gogglelensprotector",
    path: "/:locale()/shop/accessories/goggle-lens-protector",
    meta: {"sku":"gogglelensprotector","baseSku":"gogglelensprotector","id":"bvu6ro2qS4ii-_BEftshuw","index":true,"title":"Goggle Lens Protector","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/accessories/goggle-lens-protector"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_airton",
    path: "/:locale()/shop/signature-series/airton-cozzolino-zephyrs-sunglasses",
    meta: {"sku":"zephyrs-le_airton","baseSku":"Zephyrs","id":"118500741","index":true,"title":"SunGod Airton Cozzolino Signature Series","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/airton-cozzolino-zephyrs-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_8desertsand",
    path: "/:locale()/shop/limited-edition/desert-sand/sierras",
    meta: {"sku":"sierras-le_8desertsand","baseSku":"sierras","id":"GXwjB5B7QKWPbAT7v6JUrg","index":true,"title":"Desert Sand Sierras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/desert-sand/sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_8desertsand",
    path: "/:locale()/shop/limited-edition/desert-sand/tokas",
    meta: {"sku":"tokas-le_8desertsand","baseSku":"tokas","id":"ezLkYWlhSeCv5vEH7Zi_oA","index":true,"title":"Desert Sand Tokas™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/desert-sand/tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultras-le_desertsand",
    path: "/:locale()/shop/limited-edition/desert-sand/ultras",
    meta: {"sku":"ultras-le_desertsand","baseSku":"Ultras","id":"W7gZp5KmTD6inDt1tI6FcQ","index":true,"title":"Desert Sand Ultras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/desert-sand/ultras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-gts-le_geraintthomas",
    path: "/:locale()/shop/limited-edition/geraint-thomas-gts-sunglasses",
    meta: {"sku":"gts-le_geraintthomas","baseSku":"gts-le_geraintthomas","id":"116703945","index":true,"title":"SunGod GTs Signature Series™","theme":"silverblue","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/geraint-thomas-gts-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_newera",
    path: "/:locale()/shop/limited-edition/new-era-zephyrs-sunglasses",
    meta: {"sku":"zephyrs-le_newera","baseSku":"zephyrs","id":"JPnQ6nPtRyy9-sJ0NACMrQ","index":true,"title":"Limited Edition SunGod x New Era Zephyrs™ Sunglasses.","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-zephyrs-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln4-silverstone",
    path: "/:locale()/shop/limited-edition/lando-norris-silverstone-zephyrs",
    meta: {"sku":"zephyrs-le_ln4-silverstone","baseSku":"zephyrs","id":"Aj4h9wrxRlOXXtEY_nXuLg","index":true,"title":"Lando Norris Silverstone Zephyrs™ │ SunGod. See Better.","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-silverstone-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln4-25",
    path: "/:locale()/shop/limited-edition/lando-norris-zephyrs-25",
    meta: {"sku":"zephyrs-le_ln4-25","baseSku":"zephyrs","id":"QjZOVAv0Q4ybN41ELCV12A","index":true,"title":"Limited Edition Lando Norris Sunglasses - Zephyrs™","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-zephyrs-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_silverstone",
    path: "/:locale()/shop/limited-edition/lando-norris-zephyrs-silverstone",
    meta: {"sku":"zephyrs-le_silverstone","baseSku":"zephyrs","id":"133591413","index":true,"title":" Lando Norris Silverstone Zephyrs™","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-zephyrs-silverstone"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_newera",
    path: "/:locale()/shop/limited-edition/new-era-classics4-sunglasses",
    meta: {"sku":"classics4-le_newera","baseSku":"classics4","id":"QGcnJrS1TKu-VX3lRQEkqw","index":true,"title":"Limited Edition SunGod x New Era Classics⁴ Sunglasses","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-classics4-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics4-le_padrescc",
    path: "/:locale()/shop/limited-edition/classics4-le_padres-cc",
    meta: {"sku":"classics4-le_padrescc","baseSku":"classics4","id":"BB-TFv2zQ0qjQ9CgUYy_Zg","index":true,"title":"SD Padres City Connect Classics⁴: Official Eyewear Supplier","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/classics4-le_padres-cc"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclaren",
    path: "/:locale()/shop/limited-edition/mclaren-smoke-sierras",
    meta: {"sku":"sierras-le_mclaren","baseSku":"sierras","id":"68407946","index":true,"title":"SunGod McLaren F1 Team Sierras™ - Smoke","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-smoke-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_8tripleblack",
    path: "/:locale()/shop/limited-edition/triple-black/sierras",
    meta: {"sku":"sierras-le_8tripleblack","baseSku":"sierras","id":"IVFnSz8hSRu3c8hFCgjKrw","index":true,"title":"Triple Black Sierras™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/triple-black/sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airas-le_tripleblack",
    path: "/:locale()/shop/limited-edition/triple-black/airas",
    meta: {"sku":"airas-le_tripleblack","baseSku":"airas","id":"HO_pqXXNQUOl1C2I4bFvDg","index":true,"title":"Triple Black Airas™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/triple-black/airas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_sas",
    path: "/:locale()/shop/limited-edition/sas-renegades",
    meta: {"sku":"renegades-le_sas","baseSku":"renegades","id":"122678597","index":true,"title":"Surfers Against Sewage Collection - Renegades™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sas-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_op81",
    path: "/:locale()/shop/limited-edition/oscar-piastri-renegades",
    meta: {"sku":"renegades-le_op81","baseSku":"renegades","id":"MSQwKphHRSiCF6QUlPt7ug","index":true,"title":"Oscar Piastri x SunGod OP81 Renegades™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/oscar-piastri-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren25-plus",
    path: "/:locale()/shop/limited-edition/mclaren25-renegades-plus",
    meta: {"sku":"renegades-le_mclaren25-plus","baseSku":"renegades","id":"HWakJstDSMybWZqPYHTKxw","index":true,"title":" SunGod McLaren F1 Team Renegades™ Plus","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren25-renegades-plus"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_8tripleblack",
    path: "/:locale()/shop/limited-edition/triple-black/renegades",
    meta: {"sku":"renegades-le_8tripleblack","baseSku":"renegades","id":"DAuadQFAQdOkW-NF0EhTOQ","index":true,"title":"Triple Black Renegades™","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/triple-black/renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren25",
    path: "/:locale()/shop/limited-edition/mclaren-renegades-25",
    meta: {"sku":"renegades-le_mclaren25","baseSku":"renegades","id":"O2NlibTHQ8-KIZQfTdAkXQ","index":true,"title":"McLaren F1 Team SunGod Renegades™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-renegades-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_ineosgrenadiers",
    path: "/:locale()/shop/limited-edition/ineos-grenadiers-vulcans",
    meta: {"sku":"vulcans-le_ineosgrenadiers","baseSku":"vulcans","id":"106462647","index":true,"title":"INEOS Grenadiers Team Edition Vulcans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-grenadiers-vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airas-le_wiv",
    path: "/:locale()/shop/limited-edition/wiv-sungod",
    meta: {"sku":"airas-le_wiv","baseSku":"airas","id":"121755307","index":true,"title":"WiV SunGod Limited Edition Velans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/wiv-sungod"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans-le_canyon",
    path: "/:locale()/shop/limited-edition/canyon-dhb-sungod",
    meta: {"sku":"velans-le_canyon","baseSku":"velans","id":"102391857","index":true,"title":"Canyon DHB SunGod Limited Edition Velans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/canyon-dhb-sungod"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans-le_ineosgrenadiers",
    path: "/:locale()/shop/limited-edition/ineos-grenadiers-velans",
    meta: {"sku":"velans-le_ineosgrenadiers","baseSku":"velans","id":"106462652","index":true,"title":"INEOS Grenadiers Team Edition Velans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-grenadiers-velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans-le_tompidcock",
    path: "/:locale()/shop/limited-edition/tom-pidock-velans-sunglasses",
    meta: {"sku":"velans-le_tompidcock","baseSku":"velans","id":"122225553","index":true,"title":"Tom Pidcock Signature Series Velans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/tom-pidock-velans-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velans-le_momentum",
    path: "/:locale()/shop/limited-edition/momentum-velans",
    meta: {"sku":"velans-le_momentum","baseSku":"velans","id":"122604808","index":true,"title":"SunGod Momentum Velans™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/momentum-velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_pauline",
    path: "/:locale()/shop/limited-edition/pauline-ferrand-prevot-vulcans",
    meta: {"sku":"vulcans-le_pauline","baseSku":"vulcans","id":"fwURvGsXSk2S8dX4ZkrHJQ","index":true,"title":"Pauline Ferrand-Prévot Limited Edition Vulcans™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/pauline-ferrand-prevot-vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_padres",
    path: "/:locale()/shop/limited-edition/vulcans-le_padres",
    meta: {"sku":"vulcans-le_padres","baseSku":"vulcans","id":"Q8yFPCMkQL2J7_WTX-3NuQ","index":true,"title":"San Diego Padres Vulcans™: Official Eyewear Supplier","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/vulcans-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_padrescc",
    path: "/:locale()/shop/limited-edition/vulcans-le_padres-cc",
    meta: {"sku":"vulcans-le_padrescc","baseSku":"vulcans","id":"APRfWVhiSTC2OMbi8ze7Gw","index":true,"title":"SD Padres City Connect Vulcans™: Official Eyewear Supplier","theme":"sungod","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/vulcans-le_padres-cc"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_tekkerz",
    path: "/:locale()/shop/limited-edition/tekkerz",
    meta: {"sku":"vulcans-le_tekkerz","baseSku":"vulcans","id":"143334600","index":true,"title":"Tekkerz Limited Edition Vulcanz™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/tekkerz"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcans-le_momentum",
    path: "/:locale()/shop/limited-edition/momentum-vulcans",
    meta: {"sku":"vulcans-le_momentum","baseSku":"vulcans","id":"122601864","index":true,"title":"SunGod Momentum Vulcans™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/momentum-vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_mclaren24",
    path: "/:locale()/shop/limited-edition/mclaren-zephyrs",
    meta: {"sku":"zephyrs-le_mclaren24","baseSku":"zephyrs","id":"ParremfZTZmkL1OVgxBw1A","index":true,"title":"Limited Edition McLaren Zephyrs Sunglasses.","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_monaco23",
    path: "/:locale()/shop/limited-edition/mclaren-monaco-zephyrs",
    meta: {"sku":"zephyrs-le_monaco23","baseSku":"Zephyrs","id":"110553740","index":true,"title":"McLaren F1 Monaco Triple Crown Zephyrs™️ ","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-monaco-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_solstice",
    path: "/:locale()/shop/limited-edition/solstice-zephyrs",
    meta: {"sku":"zephyrs-le_solstice","baseSku":"zephyrs","id":"dby2dnJvR8im4N0ZRemV2Q","index":true,"title":"Summer Solstice Limited Edition Zephyrs™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/solstice-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_ln4clear",
    path: "/:locale()/shop/limited-edition/lando-norris-clear-zephyrs",
    meta: {"sku":"zephyrs-le_ln4clear","baseSku":"zephyrs","id":"DrNtkkikSs-wgd85gqQ5ag","index":true,"title":"Limited Edition Lando Norris Sunglasses - SunGod Zephyrs™","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/lando-norris-clear-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-zephyrs-le_mclaren24lasvegas",
    path: "/:locale()/shop/limited-edition/las-vegas-mclaren-zephyrs",
    meta: {"sku":"zephyrs-le_mclaren24lasvegas","baseSku":"zephyrs","id":"Tt55dfZeTMObQNukg1HL3A","index":true,"title":"SunGod x McLaren Las Vegas Zephyrs™ Sunglasses","theme":"purple","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/las-vegas-mclaren-zephyrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren24",
    path: "/:locale()/shop/limited-edition/mclaren-smoke-renegades-2024",
    meta: {"sku":"renegades-le_mclaren24","baseSku":"renegades","id":"f7SZtdKdRyKQRKVaaeCVPA","index":true,"title":"SunGod McLaren F1 Team Renegades™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-smoke-renegades-2024"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclarenmiami23",
    path: "/:locale()/shop/limited-edition/mclaren-miami-renegades-23",
    meta: {"sku":"renegades-le_mclarenmiami23","baseSku":"renegades","id":"106393267","index":true,"title":"McLaren Miami Renegades™","theme":"miami","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-miami-renegades-23"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclaren",
    path: "/:locale()/shop/limited-edition/mclaren-smoke-renegades",
    meta: {"sku":"renegades-le_mclaren","baseSku":"renegades","id":"69566773","index":true,"title":"SunGod McLaren F1 Team Renegades™ - Smoke","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-smoke-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclarenplus",
    path: "/:locale()/shop/limited-edition/mclaren-fire-renegades",
    meta: {"sku":"renegades-le_mclarenplus","baseSku":"renegades","id":"69566774","index":true,"title":" SunGod McLaren F1 Team Renegades™ - Fire","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-fire-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_rfu",
    path: "/:locale()/shop/limited-edition/rfu-renegades",
    meta: {"sku":"renegades-le_rfu","baseSku":"renegades","id":"69566904","index":true,"title":"SunGod x RFU 150 Renegades™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/rfu-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-renegades-le_mclarenmiami",
    path: "/:locale()/shop/limited-edition/mclaren-miami-renegades",
    meta: {"sku":"renegades-le_mclarenmiami","baseSku":"renegades","id":"121269455","index":true,"title":"McLaren Miami Renegades™","theme":"miami","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-miami-renegades"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics3-le_airton",
    path: "/:locale()/shop/signature-series/airton-cozzolino",
    meta: {"sku":"classics3-le_airton","baseSku":"classics3","id":"68051738","index":true,"title":"SunGod Airton Cozzolino Signature Series","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/airton-cozzolino"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics3-le_sas",
    path: "/:locale()/shop/limited-edition/sas-classics3",
    meta: {"sku":"classics3-le_sas","baseSku":"classics3","id":"122678655","index":true,"title":"Surfers Against Sewage Collection - Classics³","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sas-classics3"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics3",
    path: "/:locale()/shop/sunglasses/classics3",
    meta: {"sku":"classics3","baseSku":"classics3","id":"63537436","index":true,"title":"SunGod Classics³ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/sunglasses/classics3"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_ln4",
    path: "/:locale()/shop/limited-edition/mclaren-lando-norris",
    meta: {"sku":"sierras-le_ln4","baseSku":"sierras","id":"69567203","index":true,"title":"SunGod Lando LN4™ Sierras","theme":"ln4","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-lando-norris"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclaren24monaco",
    path: "/:locale()/shop/limited-edition/mclaren-monaco-sierras-2024",
    meta: {"sku":"sierras-le_mclaren24monaco","baseSku":"sierras","id":"eQJ6CPPmTg6lYrVKJ_PzHg","index":true,"title":"McLaren F1 Team Monaco Limited Edition Sierras™ ","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-monaco-sierras-2024"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclaren24",
    path: "/:locale()/shop/limited-edition/mclaren-smoke-sierras-2024",
    meta: {"sku":"sierras-le_mclaren24","baseSku":"sierras","id":"Ao8Vq_eSSrKBv-p44y0mxQ","index":true,"title":"SunGod McLaren F1 Team Sierras™ ","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-smoke-sierras-2024"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_katieo",
    path: "/:locale()/shop/signature-series/katie-ormerod",
    meta: {"sku":"sierras-le_katieo","baseSku":"sierras","id":"100386006","index":true,"title":"Katie Ormerod Signature Series Sierras™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/signature-series/katie-ormerod"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclarenmonaco",
    path: "/:locale()/shop/limited-edition/mclaren-monaco-sierras",
    meta: {"sku":"sierras-le_mclarenmonaco","baseSku":"sierras","id":"121508419","index":true,"title":"McLaren Monaco Sierras™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-monaco-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_mclarenplus",
    path: "/:locale()/shop/limited-edition/mclaren-fire-sierras",
    meta: {"sku":"sierras-le_mclarenplus","baseSku":"sierras","id":"69566624","index":true,"title":"SunGod McLaren F1 Team Sierras™ - Fire","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-fire-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_sas",
    path: "/:locale()/shop/limited-edition/sas-sierras",
    meta: {"sku":"sierras-le_sas","baseSku":"sierras","id":"122607157","index":true,"title":"Surfers Against Sewage - Sierras™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sas-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_sailgp",
    path: "/:locale()/shop/limited-edition/sailgp-sierras",
    meta: {"sku":"sierras-le_sailgp","baseSku":"sierras","id":"122520229","index":true,"title":"Great Britain SailGP Sierras™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sailgp-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sierras-le_ineosbritannia",
    path: "/:locale()/shop/limited-edition/ineos-britannia-sierras",
    meta: {"sku":"sierras-le_ineosbritannia","baseSku":"sierras","id":"144993428","index":true,"title":"Limited Edition INEOS Britannia Sierras™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-britannia-sierras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-miras-le_grape",
    path: "/:locale()/shop/limited-edition/grape-miras",
    meta: {"sku":"miras-le_grape","baseSku":"miras","id":"VnYluIUEQoqFtQMWi9N9LA","index":true,"title":"Limited Edition Grape Miras™","theme":"grape","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/grape-miras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempests-le_ineosbritannia",
    path: "/:locale()/shop/limited-edition/ineos-britannia-tempests",
    meta: {"sku":"tempests-le_ineosbritannia","baseSku":"tempests","id":"144993453","index":true,"title":"INEOS Britannia Tempests™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/ineos-britannia-tempests"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempests-le_sailgp",
    path: "/:locale()/shop/limited-edition/sailgp-tempests",
    meta: {"sku":"tempests-le_sailgp","baseSku":"tempests","id":"143783828","index":true,"title":"SunGod x Great Britain SailGP Team Collection - Tempests™","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/sailgp-tempests"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempests-le_mclarenmx",
    path: "/:locale()/shop/limited-edition/mclaren-extreme-e-tempests",
    meta: {"sku":"tempests-le_mclarenmx","baseSku":"tempests","id":"122433054","index":true,"title":"SunGod NEOM McLaren Extreme E Tempests™","theme":"mclaren-mx","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-extreme-e-tempests"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tempests-le_mclarenplus",
    path: "/:locale()/shop/limited-edition/mclaren-plus-tempests-polarised-sunglasses",
    meta: {"sku":"tempests-le_mclarenplus","baseSku":"tempests","id":"119038077","index":true,"title":"SunGod McLaren F1 Team Tempests™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-plus-tempests-polarised-sunglasses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_mclaren60th",
    path: "/:locale()/shop/limited-edition/mclaren-60th-tokas",
    meta: {"sku":"tokas-le_mclaren60th","baseSku":"tokas","id":"172038964","index":true,"title":"McLaren F1 Team 60th Edition Tokas™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/mclaren-60th-tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_solstice",
    path: "/:locale()/shop/limited-edition/solstice-tokas",
    meta: {"sku":"tokas-le_solstice","baseSku":"tokas","id":"YgVshCF5TdmoN4ayxZeg8g","index":true,"title":"Summer Solstice Limited Edition Tokas™","theme":"mclaren","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/solstice-tokas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-tokas-le_mclarenwinners",
    path: "/:locale()/shop/mclaren/winners",
    meta: {"sku":"tokas-le_mclarenwinners","baseSku":"tokas","id":"AIOtQiOuTEisSffaltHEfA","index":true,"title":"SunGod x McLaren Winners' Collection Sunglasses","theme":"dark-chrome","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/mclaren/winners"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-velansck",
    path: "/:locale()/shop/parts/velans",
    meta: {"sku":"velansck","baseSku":"velans","id":"63537421","index":true,"title":" SunGod Velans™ Conversion Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/velans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airasck",
    path: "/:locale()/shop/parts/airas",
    meta: {"sku":"airasck","baseSku":"airas","id":"63537496","index":true,"title":" SunGod Airas™ Conversion Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/airas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcansck",
    path: "/:locale()/shop/parts/vulcans",
    meta: {"sku":"vulcansck","baseSku":"vulcans","id":"63537393","index":true,"title":" SunGod Vulcans™ Conversion Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-forty2slrk",
    path: "/:locale()/shop/lenses/forty2s",
    meta: {"sku":"forty2slrk","baseSku":"forty2slrk","id":"XT8BNY7HTQaz_2UzJq0hLw","index":true,"title":"SunGod FORTY2s™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/forty2s"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-cap-le_newera950sm",
    path: "/:locale()/shop/limited-edition/new-era-9-fifty-cap-small-medium",
    meta: {"sku":"cap-le_newera950sm","baseSku":"cap-le_newera950","id":"Mj1zoQ7yQvK3hbUkpc0-NA","index":true,"title":"SunGod x New Era Headwear Collection. ","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-9-fifty-cap-small-medium"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-cap-le_newera950ml",
    path: "/:locale()/shop/limited-edition/new-era-9-fifty-cap-medium-large",
    meta: {"sku":"cap-le_newera950ml","baseSku":"cap-le_newera950","id":"U6dVYl44TQahqj5erOm9pQ","index":true,"title":"9FIFTY Cap: SunGod x New Era","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-9-fifty-cap-medium-large"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-cap-le_newera950",
    path: "/:locale()/shop/limited-edition/new-era-9-fifty-cap",
    meta: {"sku":"cap-le_newera950","baseSku":"cap-le_newera950","id":"T5TdPijlREincoQfEYgl4A","index":true,"title":"SunGod x New Era Headwear Collection. ","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-9-fifty-cap"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-cap-le_newera940",
    path: "/:locale()/shop/limited-edition/new-era-9-forty-cap",
    meta: {"sku":"cap-le_newera940","baseSku":"cap-le_newera940","id":"amn0s5feTm2KqsINANQfng","index":true,"title":"9FORTY Cap: SunGod x New Era ","theme":"gold","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/new-era-9-forty-cap"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics3-le_rfu22",
    path: "/:locale()/shop/limited-edition/england-rugby-classics",
    meta: {"sku":"classics3-le_rfu22","baseSku":"classics3","id":"102317858","index":true,"title":"SunGod x England Rugby Sunglasses -  Classics³ ","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/limited-edition/england-rugby-classics"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-classics3lrk",
    path: "/:locale()/shop/lenses/classics3",
    meta: {"sku":"classics3lrk","baseSku":"classics3","id":"63537437","index":true,"title":"SunGod Classics³ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/classics3"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-airaslrk",
    path: "/:locale()/shop/lenses/airas",
    meta: {"sku":"airaslrk","baseSku":"airas","id":"63537487","index":true,"title":" SunGod Airas™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/airas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ultraslrk",
    path: "/:locale()/shop/lenses/ultras",
    meta: {"sku":"ultraslrk","baseSku":"ultraslrk","id":"121140949","index":true,"title":"SunGod Ultras™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/ultras"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vulcanslrk",
    path: "/:locale()/shop/lenses/vulcans",
    meta: {"sku":"vulcanslrk","baseSku":"vulcans","id":"63537402","index":true,"title":" SunGod Vulcans™ Lens Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/lenses/vulcans"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-egiftcard",
    path: "/:locale()/gifts",
    meta: {"sku":"egiftcard","baseSku":"egiftcard","id":"94211574","index":true,"theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/gifts"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ullrsparts",
    path: "/:locale()/shop/parts/ullrs",
    meta: {"sku":"ullrsparts","baseSku":"ullrs","id":"IdrMUcQjT2WsNl6pLttpag","index":true,"title":" SunGod Ullrs™ Parts Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/ullrs"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-vanguardsparts",
    path: "/:locale()/shop/parts/vanguards",
    meta: {"sku":"vanguardsparts","baseSku":"vanguards","id":"63537443","index":true,"title":" SunGod Vanguards™ Parts Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/vanguards"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-snipersparts",
    path: "/:locale()/shop/parts/snipers",
    meta: {"sku":"snipersparts","baseSku":"snipers","id":"63537450","index":true,"title":" SunGod Snipers™ Parts Kit","theme":"","extendedPage":true,"pageType":"Product Page","unlocalisedPath":"/shop/parts/snipers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-unibet-rose-rockets",
    path: "/:locale()/shop/unibet-rose-rockets",
    meta: {"sku":"velans2-le_rockets26","slug":"unibet-rose-rockets","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod x Unibet Rose Rockets | ","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/unibet-rose-rockets"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-unibet-rose-rockets-velans2-le_rockets26",
    path: "/:locale()/shop/unibet-rose-rockets/velans2-le_rockets26",
    meta: {"sku":"velans2-le_rockets26","slug":"unibet-rose-rockets","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/unibet-rose-rockets/velans2-le_rockets26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-unibet-rose-rockets-miras-le_rockets26",
    path: "/:locale()/shop/unibet-rose-rockets/miras-le_rockets26",
    meta: {"sku":"miras-le_rockets26","slug":"unibet-rose-rockets","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/unibet-rose-rockets/miras-le_rockets26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-grenadiers",
    path: "/:locale()/shop/ineos-grenadiers",
    meta: {"sku":"velans2-le_ineos26","slug":"ineos-grenadiers","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Netcompany INEOS Cycling Team Edition Sunglasses","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/ineos-grenadiers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-grenadiers-velans2-le_ineos26",
    path: "/:locale()/shop/ineos-grenadiers/velans2-le_ineos26",
    meta: {"sku":"velans2-le_ineos26","slug":"ineos-grenadiers","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/ineos-grenadiers/velans2-le_ineos26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-grenadiers-zephyrs-le_ineos26",
    path: "/:locale()/shop/ineos-grenadiers/zephyrs-le_ineos26",
    meta: {"sku":"zephyrs-le_ineos26","slug":"ineos-grenadiers","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/ineos-grenadiers/zephyrs-le_ineos26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers",
    path: "/:locale()/shop/mclaren-drivers",
    meta: {"sku":"zephyrs-le_mclaren26-silverstone","slug":"mclaren-drivers","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod x McLaren Formula 1 Team Sunglasses","theme":"ln4","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mclaren-drivers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers-zephyrs-le_mclaren26-silverstone",
    path: "/:locale()/shop/mclaren-drivers/zephyrs-le_mclaren26-silverstone",
    meta: {"sku":"zephyrs-le_mclaren26-silverstone","slug":"mclaren-drivers","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren-drivers/zephyrs-le_mclaren26-silverstone"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers-zephyrs-le_ln1-26",
    path: "/:locale()/shop/mclaren-drivers/zephyrs-le_ln1-26",
    meta: {"sku":"zephyrs-le_ln1-26","slug":"mclaren-drivers","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren-drivers/zephyrs-le_ln1-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers-zephyrs-le_ln1-neon26",
    path: "/:locale()/shop/mclaren-drivers/zephyrs-le_ln1-neon26",
    meta: {"sku":"zephyrs-le_ln1-neon26","slug":"mclaren-drivers","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren-drivers/zephyrs-le_ln1-neon26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers-renegades-le_op81-26",
    path: "/:locale()/shop/mclaren-drivers/renegades-le_op81-26",
    meta: {"sku":"renegades-le_op81-26","slug":"mclaren-drivers","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren-drivers/renegades-le_op81-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-drivers-renegades-le_op81-melbourne26",
    path: "/:locale()/shop/mclaren-drivers/renegades-le_op81-melbourne26",
    meta: {"sku":"renegades-le_op81-melbourne26","slug":"mclaren-drivers","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren-drivers/renegades-le_op81-melbourne26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-aurora",
    path: "/:locale()/shop/aurora",
    meta: {"sku":"forty2s-42f_Ineonblue-42le_8smoke-pli_Bblue","slug":"aurora","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod Aurora","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/aurora"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-aurora-forty2s-42f_Ineonblue-42le_8smoke-pli_Bblue",
    path: "/:locale()/shop/aurora/forty2s-42f_Ineonblue-42le_8smoke-pli_Bblue",
    meta: {"sku":"forty2s-42f_Ineonblue-42le_8smoke-pli_Bblue","slug":"aurora","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/aurora/forty2s-42f_Ineonblue-42le_8smoke-pli_Bblue"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren",
    path: "/:locale()/shop/mclaren",
    meta: {"sku":"renegades-le_mclaren26","slug":"mclaren","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod x McLaren Formula 1 Team Sunglasses","theme":"mclaren","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mclaren"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-renegades-le_mclaren26",
    path: "/:locale()/shop/mclaren/renegades-le_mclaren26",
    meta: {"sku":"renegades-le_mclaren26","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/renegades-le_mclaren26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-renegades-le_mclaren26-plus",
    path: "/:locale()/shop/mclaren/renegades-le_mclaren26-plus",
    meta: {"sku":"renegades-le_mclaren26-plus","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/renegades-le_mclaren26-plus"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-renegades-le_mclaren26-papaya",
    path: "/:locale()/shop/mclaren/renegades-le_mclaren26-papaya",
    meta: {"sku":"renegades-le_mclaren26-papaya","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/renegades-le_mclaren26-papaya"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-sierras-le_mclaren26",
    path: "/:locale()/shop/mclaren/sierras-le_mclaren26",
    meta: {"sku":"sierras-le_mclaren26","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/sierras-le_mclaren26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-sierras-le_mclaren26-papaya",
    path: "/:locale()/shop/mclaren/sierras-le_mclaren26-papaya",
    meta: {"sku":"sierras-le_mclaren26-papaya","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/sierras-le_mclaren26-papaya"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-tokas-le_mclaren26-tortoise",
    path: "/:locale()/shop/mclaren/tokas-le_mclaren26-tortoise",
    meta: {"sku":"tokas-le_mclaren26-tortoise","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/tokas-le_mclaren26-tortoise"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-miras-le_mclaren26",
    path: "/:locale()/shop/mclaren/miras-le_mclaren26",
    meta: {"sku":"miras-le_mclaren26","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/miras-le_mclaren26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-forty2s-le_mclaren26-papaya",
    path: "/:locale()/shop/mclaren/forty2s-le_mclaren26-papaya",
    meta: {"sku":"forty2s-le_mclaren26-papaya","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/forty2s-le_mclaren26-papaya"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-miras-le_mclaren26-tortoise",
    path: "/:locale()/shop/mclaren/miras-le_mclaren26-tortoise",
    meta: {"sku":"miras-le_mclaren26-tortoise","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/miras-le_mclaren26-tortoise"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-zephyrs-le_ln1-26",
    path: "/:locale()/shop/mclaren/zephyrs-le_ln1-26",
    meta: {"sku":"zephyrs-le_ln1-26","slug":"mclaren","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/zephyrs-le_ln1-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-zephyrs-le_ln1-neon26",
    path: "/:locale()/shop/mclaren/zephyrs-le_ln1-neon26",
    meta: {"sku":"zephyrs-le_ln1-neon26","slug":"mclaren","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/zephyrs-le_ln1-neon26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-renegades-le_op81-26",
    path: "/:locale()/shop/mclaren/renegades-le_op81-26",
    meta: {"sku":"renegades-le_op81-26","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/renegades-le_op81-26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mclaren-renegades-le_op81-melbourne26",
    path: "/:locale()/shop/mclaren/renegades-le_op81-melbourne26",
    meta: {"sku":"renegades-le_op81-melbourne26","slug":"mclaren","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mclaren/renegades-le_op81-melbourne26"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-brick",
    path: "/:locale()/shop/brick",
    meta: {"sku":"tokas-le_8londonbrick","slug":"brick","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Brick Collection │ SunGod. See Better.","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/brick"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-brick-tokas-le_8londonbrick",
    path: "/:locale()/shop/brick/tokas-le_8londonbrick",
    meta: {"sku":"tokas-le_8londonbrick","slug":"brick","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/brick/tokas-le_8londonbrick"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-brick-zephyrs-le_8londonbrick",
    path: "/:locale()/shop/brick/zephyrs-le_8londonbrick",
    meta: {"sku":"zephyrs-le_8londonbrick","slug":"brick","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/brick/zephyrs-le_8londonbrick"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-brick-vulcans-le_8londonbrick",
    path: "/:locale()/shop/brick/vulcans-le_8londonbrick",
    meta: {"sku":"vulcans-le_8londonbrick","slug":"brick","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/brick/vulcans-le_8londonbrick"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-triple-black",
    path: "/:locale()/shop/triple-black",
    meta: {"sku":"renegades-le_8tripleblack","slug":"triple-black","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Triple Black Collection │ SunGod. See Better.","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/triple-black"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-triple-black-renegades-le_8tripleblack",
    path: "/:locale()/shop/triple-black/renegades-le_8tripleblack",
    meta: {"sku":"renegades-le_8tripleblack","slug":"triple-black","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/triple-black/renegades-le_8tripleblack"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-triple-black-sierras-le_8tripleblack",
    path: "/:locale()/shop/triple-black/sierras-le_8tripleblack",
    meta: {"sku":"sierras-le_8tripleblack","slug":"triple-black","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/triple-black/sierras-le_8tripleblack"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-triple-black-airas-le_tripleblack",
    path: "/:locale()/shop/triple-black/airas-le_tripleblack",
    meta: {"sku":"airas-le_tripleblack","slug":"triple-black","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/triple-black/airas-le_tripleblack"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive",
    path: "/:locale()/shop/sale/archive",
    meta: {"sku":"renegades-le_mclaren25","slug":"sale__archive","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod x McLaren Formula 1 Team Sunglasses","theme":"mclaren","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/sale/archive"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-renegades-le_mclaren25",
    path: "/:locale()/shop/sale/archive/renegades-le_mclaren25",
    meta: {"sku":"renegades-le_mclaren25","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/renegades-le_mclaren25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-renegades-le_mclaren25-plus",
    path: "/:locale()/shop/sale/archive/renegades-le_mclaren25-plus",
    meta: {"sku":"renegades-le_mclaren25-plus","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/renegades-le_mclaren25-plus"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-miras-le_mclaren25",
    path: "/:locale()/shop/sale/archive/miras-le_mclaren25",
    meta: {"sku":"miras-le_mclaren25","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/miras-le_mclaren25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-zephyrs-le_mclaren25",
    path: "/:locale()/shop/sale/archive/zephyrs-le_mclaren25",
    meta: {"sku":"zephyrs-le_mclaren25","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/zephyrs-le_mclaren25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-zephyrs-le_ln4-25",
    path: "/:locale()/shop/sale/archive/zephyrs-le_ln4-25",
    meta: {"sku":"zephyrs-le_ln4-25","slug":"sale__archive","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/zephyrs-le_ln4-25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-zephyrs-le_ln4-silverstone",
    path: "/:locale()/shop/sale/archive/zephyrs-le_ln4-silverstone",
    meta: {"sku":"zephyrs-le_ln4-silverstone","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/zephyrs-le_ln4-silverstone"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-zephyrs-le_ln4-neon",
    path: "/:locale()/shop/sale/archive/zephyrs-le_ln4-neon",
    meta: {"sku":"zephyrs-le_ln4-neon","slug":"sale__archive","isComposite":true,"index":false,"theme":"ln4","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/zephyrs-le_ln4-neon"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-renegades-le_op81",
    path: "/:locale()/shop/sale/archive/renegades-le_op81",
    meta: {"sku":"renegades-le_op81","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/renegades-le_op81"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-vulcans-le_mclaren25",
    path: "/:locale()/shop/sale/archive/vulcans-le_mclaren25",
    meta: {"sku":"vulcans-le_mclaren25","slug":"sale__archive","isComposite":true,"index":false,"theme":"mclaren","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/vulcans-le_mclaren25"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sale__archive-miras-le_mclaren25-miami",
    path: "/:locale()/shop/sale/archive/miras-le_mclaren25-miami",
    meta: {"sku":"miras-le_mclaren25-miami","slug":"sale__archive","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sale/archive/miras-le_mclaren25-miami"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-desert-sand",
    path: "/:locale()/shop/desert-sand",
    meta: {"sku":"sierras-le_8desertsand","slug":"desert-sand","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Desert Collection │ SunGod. See Better.","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/desert-sand"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-desert-sand-sierras-le_8desertsand",
    path: "/:locale()/shop/desert-sand/sierras-le_8desertsand",
    meta: {"sku":"sierras-le_8desertsand","slug":"desert-sand","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/desert-sand/sierras-le_8desertsand"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-desert-sand-tokas-le_8desertsand",
    path: "/:locale()/shop/desert-sand/tokas-le_8desertsand",
    meta: {"sku":"tokas-le_8desertsand","slug":"desert-sand","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/desert-sand/tokas-le_8desertsand"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-desert-sand-ultras-le_desertsand",
    path: "/:locale()/shop/desert-sand/ultras-le_desertsand",
    meta: {"sku":"ultras-le_desertsand","slug":"desert-sand","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/desert-sand/ultras-le_desertsand"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-desert-sand-velans-le_desertsand",
    path: "/:locale()/shop/desert-sand/velans-le_desertsand",
    meta: {"sku":"velans-le_desertsand","slug":"desert-sand","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/desert-sand/velans-le_desertsand"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-britannia",
    path: "/:locale()/shop/ineos-britannia",
    meta: {"sku":"tempests-le_ineosbritannia","slug":"ineos-britannia","isComposite":true,"isCompositeRoot":true,"index":true,"title":"INEOS Britannia Sunglasses Collection","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/ineos-britannia"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-britannia-tempests-le_ineosbritannia",
    path: "/:locale()/shop/ineos-britannia/tempests-le_ineosbritannia",
    meta: {"sku":"tempests-le_ineosbritannia","slug":"ineos-britannia","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/ineos-britannia/tempests-le_ineosbritannia"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-ineos-britannia-sierras-le_ineosbritannia",
    path: "/:locale()/shop/ineos-britannia/sierras-le_ineosbritannia",
    meta: {"sku":"sierras-le_ineosbritannia","slug":"ineos-britannia","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/ineos-britannia/sierras-le_ineosbritannia"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-surfers-against-sewage",
    path: "/:locale()/shop/surfers-against-sewage",
    meta: {"sku":"renegades-le_sas","slug":"surfers-against-sewage","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Surfers Against Sewage Sunglasses","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/surfers-against-sewage"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-surfers-against-sewage-renegades-le_sas",
    path: "/:locale()/shop/surfers-against-sewage/renegades-le_sas",
    meta: {"sku":"renegades-le_sas","slug":"surfers-against-sewage","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/surfers-against-sewage/renegades-le_sas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-surfers-against-sewage-classics3-le_sas",
    path: "/:locale()/shop/surfers-against-sewage/classics3-le_sas",
    meta: {"sku":"classics3-le_sas","slug":"surfers-against-sewage","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/surfers-against-sewage/classics3-le_sas"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres",
    path: "/:locale()/shop/mlb-padres",
    meta: {"sku":"vulcans-le_padrescc","slug":"mlb-padres","isComposite":true,"isCompositeRoot":true,"index":true,"title":"San Diego Padres Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-vulcans-le_padrescc",
    path: "/:locale()/shop/mlb-padres/vulcans-le_padrescc",
    meta: {"sku":"vulcans-le_padrescc","slug":"mlb-padres","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/vulcans-le_padrescc"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-classics4-le_padrescc",
    path: "/:locale()/shop/mlb-padres/classics4-le_padrescc",
    meta: {"sku":"classics4-le_padrescc","slug":"mlb-padres","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/classics4-le_padrescc"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-vulcans-le_padres",
    path: "/:locale()/shop/mlb-padres/vulcans-le_padres",
    meta: {"sku":"vulcans-le_padres","slug":"mlb-padres","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/vulcans-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-classics4-le_padres",
    path: "/:locale()/shop/mlb-padres/classics4-le_padres",
    meta: {"sku":"classics4-le_padres","slug":"mlb-padres","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/classics4-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-zephyrs-le_padres",
    path: "/:locale()/shop/mlb-padres/zephyrs-le_padres",
    meta: {"sku":"zephyrs-le_padres","slug":"mlb-padres","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/zephyrs-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-padres-renegades-le_padres",
    path: "/:locale()/shop/mlb-padres/renegades-le_padres",
    meta: {"sku":"renegades-le_padres","slug":"mlb-padres","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-padres/renegades-le_padres"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-astros",
    path: "/:locale()/shop/mlb-astros",
    meta: {"sku":"zephyrs-le_astros","slug":"mlb-astros","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Houston Astros Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-astros"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-astros-zephyrs-le_astros",
    path: "/:locale()/shop/mlb-astros/zephyrs-le_astros",
    meta: {"sku":"zephyrs-le_astros","slug":"mlb-astros","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-astros/zephyrs-le_astros"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-astros-renegades-le_astros",
    path: "/:locale()/shop/mlb-astros/renegades-le_astros",
    meta: {"sku":"renegades-le_astros","slug":"mlb-astros","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-astros/renegades-le_astros"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-giants",
    path: "/:locale()/shop/mlb-giants",
    meta: {"sku":"renegades-le_giants","slug":"mlb-giants","isComposite":true,"isCompositeRoot":true,"index":true,"title":"San Francisco Giants Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-giants"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-giants-renegades-le_giants",
    path: "/:locale()/shop/mlb-giants/renegades-le_giants",
    meta: {"sku":"renegades-le_giants","slug":"mlb-giants","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-giants/renegades-le_giants"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-giants-zephyrs-le_giants",
    path: "/:locale()/shop/mlb-giants/zephyrs-le_giants",
    meta: {"sku":"zephyrs-le_giants","slug":"mlb-giants","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-giants/zephyrs-le_giants"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-dodgers",
    path: "/:locale()/shop/mlb-dodgers",
    meta: {"sku":"renegades-le_dodgers","slug":"mlb-dodgers","isComposite":true,"isCompositeRoot":true,"index":true,"title":"LA Dodgers Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-dodgers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-dodgers-renegades-le_dodgers",
    path: "/:locale()/shop/mlb-dodgers/renegades-le_dodgers",
    meta: {"sku":"renegades-le_dodgers","slug":"mlb-dodgers","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-dodgers/renegades-le_dodgers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-dodgers-zephyrs-le_dodgers",
    path: "/:locale()/shop/mlb-dodgers/zephyrs-le_dodgers",
    meta: {"sku":"zephyrs-le_dodgers","slug":"mlb-dodgers","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-dodgers/zephyrs-le_dodgers"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-redsox",
    path: "/:locale()/shop/mlb-redsox",
    meta: {"sku":"renegades-le_redsox","slug":"mlb-redsox","isComposite":true,"isCompositeRoot":true,"index":true,"title":"Boston Red Sox Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-redsox"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-redsox-renegades-le_redsox",
    path: "/:locale()/shop/mlb-redsox/renegades-le_redsox",
    meta: {"sku":"renegades-le_redsox","slug":"mlb-redsox","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-redsox/renegades-le_redsox"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-redsox-zephyrs-le_redsox",
    path: "/:locale()/shop/mlb-redsox/zephyrs-le_redsox",
    meta: {"sku":"zephyrs-le_redsox","slug":"mlb-redsox","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-redsox/zephyrs-le_redsox"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-yankees",
    path: "/:locale()/shop/mlb-yankees",
    meta: {"sku":"renegades-le_yankees","slug":"mlb-yankees","isComposite":true,"isCompositeRoot":true,"index":true,"title":"New York Yankees Sunglasses","theme":"sungod","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/mlb-yankees"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-yankees-renegades-le_yankees",
    path: "/:locale()/shop/mlb-yankees/renegades-le_yankees",
    meta: {"sku":"renegades-le_yankees","slug":"mlb-yankees","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-yankees/renegades-le_yankees"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-mlb-yankees-zephyrs-le_yankees",
    path: "/:locale()/shop/mlb-yankees/zephyrs-le_yankees",
    meta: {"sku":"zephyrs-le_yankees","slug":"mlb-yankees","isComposite":true,"index":false,"theme":"sungod","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/mlb-yankees/zephyrs-le_yankees"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sailgp-gbr",
    path: "/:locale()/shop/sailgp-gbr",
    meta: {"sku":"tempests-le_sailgp","slug":"sailgp-gbr","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod x Great Britain SailGP Team Sunglasses","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/sailgp-gbr"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-sailgp-gbr-tempests-le_sailgp",
    path: "/:locale()/shop/sailgp-gbr/tempests-le_sailgp",
    meta: {"sku":"tempests-le_sailgp","slug":"sailgp-gbr","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/sailgp-gbr/tempests-le_sailgp"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-momentum",
    path: "/:locale()/shop/momentum",
    meta: {"sku":"vulcans-le_momentum","slug":"momentum","isComposite":true,"isCompositeRoot":true,"index":true,"title":"SunGod Momentum Vulcans™ & Velans™ Sunglasses","theme":"","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/momentum"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-momentum-vulcans-le_momentum",
    path: "/:locale()/shop/momentum/vulcans-le_momentum",
    meta: {"sku":"vulcans-le_momentum","slug":"momentum","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/momentum/vulcans-le_momentum"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "pdp-momentum-velans-le_momentum",
    path: "/:locale()/shop/momentum/velans-le_momentum",
    meta: {"sku":"velans-le_momentum","slug":"momentum","isComposite":true,"index":false,"theme":"","extendedPage":true,"pageType":"Product Detail Page","unlocalisedPath":"/shop/momentum/velans-le_momentum"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/[product]/index.vue")
  },
  {
    name: "typeform-retailer-application-form",
    path: "/:locale()/retailer-application-form",
    meta: {"slug":"retailer-application-form","index":false,"formId":"NQdZMh7C","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/retailer-application-form"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-wear-tester-product-feedback",
    path: "/:locale()/wear-tester-product-feedback",
    meta: {"slug":"wear-tester-product-feedback","index":false,"formId":"FVjjIM19","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/wear-tester-product-feedback"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-wear-tester",
    path: "/:locale()/wear-tester",
    meta: {"slug":"wear-tester","index":false,"formId":"NgF9vly0","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/wear-tester"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-pro-deal",
    path: "/:locale()/pro-deal",
    meta: {"slug":"pro-deal","index":false,"formId":"jH1JKo6W","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/pro-deal"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-run-with-courtney",
    path: "/:locale()/run-with-courtney",
    meta: {"slug":"run-with-courtney","index":false,"formId":"w53w80ds","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/run-with-courtney"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-co-brand-form",
    path: "/:locale()/co-brand-form",
    meta: {"slug":"co-brand-form","index":false,"formId":"bbMbHzrB","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/co-brand-form"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-prescription-lenses",
    path: "/:locale()/prescription-lenses",
    meta: {"slug":"prescription-lenses","index":false,"formId":"hzs484kM","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/prescription-lenses"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-fwq-fjt-athletes",
    path: "/:locale()/fwq-fjt-athletes",
    meta: {"slug":"fwq-fjt-athletes","index":false,"formId":"eMKDck","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/fwq-fjt-athletes"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "typeform-return-authorisation",
    path: "/:locale()/return-authorisation",
    meta: {"slug":"return-authorisation","index":false,"formId":"p2nSC6","extendedPage":true,"pageType":"Form Page","unlocalisedPath":"/return-authorisation"},
    component: () => import("/vercel/path0/pages/[locale]/typeform/[slug].vue")
  },
  {
    name: "ec-running",
    path: "/:locale()/explore/running",
    meta: {"categoryId":"XMSuBQddQTmHPFNY3AMtIA","slug":"running","index":true,"theme":"explore","title":"Running | SunGod. See Better.","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/running"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-explore-running",
    path: "/:locale()/explore/explore-running",
    meta: {"categoryId":"OJqa8jUoSVGt_-WHJECpDg","slug":"explore-running","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/explore-running"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-product-guides",
    path: "/:locale()/explore/product-guides",
    meta: {"categoryId":"SynDO1jpQcWvRJO8RvO5RA","slug":"product-guides","index":true,"theme":"explore","title":"Product Guides ","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/product-guides"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-sports",
    path: "/:locale()/explore/sports",
    meta: {"categoryId":"W1G_AGtoQ2WXa5xgr8lfVQ","slug":"sports","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/sports"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-cycling",
    path: "/:locale()/explore/cycling",
    meta: {"categoryId":"fg9D88DoRIWBX9oexQZzxA","slug":"cycling","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/cycling"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-snowsports",
    path: "/:locale()/explore/snowsports",
    meta: {"categoryId":"DnvidYYgRGaOxFxzt-DquQ","slug":"snowsports","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/snowsports"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-athlete-stories",
    path: "/:locale()/explore/athlete-stories",
    meta: {"categoryId":"MywN3iPMSiyplVGFs5sW4A","slug":"athlete-stories","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/athlete-stories"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-pro-team",
    path: "/:locale()/explore/pro-team",
    meta: {"categoryId":"80143887","slug":"pro-team","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/pro-team"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-video",
    path: "/:locale()/explore/video",
    meta: {"categoryId":"80143904","slug":"video","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/video"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-stories",
    path: "/:locale()/explore/stories",
    meta: {"categoryId":"80143878","slug":"stories","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/stories"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "ec-news",
    path: "/:locale()/explore/news",
    meta: {"categoryId":"80143880","slug":"news","index":true,"theme":"explore","extendedPage":true,"pageType":"Explore Category","unlocalisedPath":"/explore/news"},
    component: () => import("/vercel/path0/pages/[locale]/explore/[category]/index.vue")
  },
  {
    name: "legacy-collection-shop__lenses",
    path: "/:locale()/shop/lenses",
    meta: {"index":true,"title":"Replacement Lenses & Parts","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/shop/lenses"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/index.vue")
  },
  {
    name: "legacy-collection-shop__parts",
    path: "/:locale()/shop/parts",
    meta: {"index":true,"title":"Goggle Parts","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/shop/parts"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/index.vue")
  },
  {
    name: "legacy-collection-shop__cases",
    path: "/:locale()/shop/cases",
    meta: {"index":true,"title":"Cases","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/shop/cases"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/index.vue")
  },
  {
    name: "legacy-collection-shop__parts__pace",
    path: "/:locale()/shop/parts/pace",
    meta: {"index":true,"title":"Pace Series™ Parts","extendedPage":true,"pageType":"Product Landing Page","unlocalisedPath":"/shop/parts/pace"},
    component: () => import("/vercel/path0/pages/[locale]/shop/[category]/index.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/*/*/cart",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]